import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, OnDestroy, Output, ViewChild, ElementRef, TemplateRef, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from '../services/common.service';
import beautify from "xml-beautifier";
declare const copyToClipboard: any;
declare var $
import { COMMA, ENTER, V, X } from "@angular/cdk/keycodes";
import { SelectionModel } from '@angular/cdk/collections';
import { AppConfigService } from '../configurations/app-config.service';
import { ToastrService } from 'ngx-toastr';
import { async } from '@angular/core/testing';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { Observable, empty, of } from 'rxjs';
import { data } from 'highcharts';
import { DataValidationComponent } from 'src/app/Model/data-validation/data-validation.component';
import { mergeMap } from 'rxjs/operators';
import { MatChipInputEvent } from "@angular/material/chips";
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { FileViewExplorerComponent } from '../file-view-explorer/file-view-explorer.component';
import { AngularEditorComponent } from '@kolkov/angular-editor';
import { ConsolidateviewfileComponent } from 'src/app/consolidateviewfile/consolidateviewfile.component';
import { CompareComponent } from '../compare/compare.component';
import { ComparePinnedComponent } from '../compare-pinned/compare-pinned.component';

import { Hl7viewerComponent } from '../hl7viewer/hl7viewer.component';
import { LoginService } from '../login/login.service';
import { Rolepermissionslst } from '../homepage/homepage.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { parseFlattenToPairs } from 'src/Utility/xml_jsonbuilder';
import { TabChangeService } from '../services/tab-change.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../confirm-dialog/confirm-dialog.component';


@Component({
  selector: "app-hubmessages",
  templateUrl: "./hubmessages.component.html",
  styleUrls: ["./hubmessages.component.scss"],
})
export class HubmessagesComponent implements OnInit, OnDestroy {
  panelOpenState;
  messageFullData = [];
  msgfieldlist: any = [];
  public parseFlattenToPairs = parseFlattenToPairs;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild("msgfieldInput", { static: false }) msgfieldInput: ElementRef<HTMLInputElement>;
  @ViewChild("fileContent", { static: false }) fileContent: any;
  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;
  @ViewChild('pinMessageDialogTemplate') pinMessageDialogTemplate!: TemplateRef<any>;
  msgfieldctrl = new FormControl("");
  pinMessageReason: string = '';
  pinMessagePinName: string = '';
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  @Output() hl7MessageEvent = new EventEmitter<string>();
  @Input() messageData;
  @Input() case360;
  @Output() case360search = new EventEmitter<string>();
  archivedbcheck: boolean = false;
  pinnedcheck: boolean = false;  // Pinned messages filter
  usernamedisplay: string;
  isLoadingroutes: boolean = false;
  isLoadingTarget: boolean = false;
  isLoadingProcesor: boolean = false;
  isLoadingsource: boolean = false;
  isParentRouteExpanded: boolean = false;
  cardHeight: number = window.innerHeight - 275;
  stagemodalheight: number = 488;
  stagemodalheighttextarea: number = 330;
  isfocus: boolean = false;
  msgfieldplaceholder: string =
    "Paste multiple values (max 100) separated by | character";
  tablediv: boolean = false;
  statusmessageMainflg: boolean = false;
  keywordsearch = "displayname";
  showDropdown: boolean = false;
  RouteNameList: any = [];
  SourceAccountList: any = [];
  TargetAccountList = <any>[];
  ProcessorList = <any>[];
  messageList = <any>[];
  messagestageList = <any>[];
  childmessageList = <any>[];
  messageTypeList = <any>[];

  selectedmessagetype: string = "";
  selectedrouteId: string = "";
  selectedrouteDisplayName: string = "";

  selectedsourceaccountid: string = "";
  selectedsourceaccountName: string = "";
  selectedtargetaccountid = "";
  selectedtargetdeployementkey = "";
  selectedtargetassociatedaccountids = "";
  selectedtargetaccountName = "";

  selectedprocessagentid = "";
  selectedprocessdisplayname = "";
  deploymentkey: string = "";
  selectedsourceassociatedaccountids: string = "";

  reactiveFormtarget: FormGroup;
  reactiveFormprocess: FormGroup;
  reactiveFormsource: FormGroup;
  reactiveFormroute: FormGroup;

  reactiveFormmessageid: FormGroup;
  reactiveFortransactionid: FormGroup;
  reactiveForentityfield: FormGroup;
  reactiveFormentity: FormGroup;
  selectedmessagestatustype: string = "ALL";

  reactiveFormmsgtype: FormGroup;
  reactiveFormmsgstatus: FormGroup;
  isAddedForReprocess: boolean;
  screenHeight: number;
  notfounddata: boolean;
  message_iot_data: any = {};
  arhivecheckbackup: boolean;
  fileidarray: any[] = [];

  logIdList = <any>[];
  caseIdList = <any>[];
  handlerList = <any>[];
  statusMirth = <any>[];
  createdDate = <any>[];
  processingDate = <any>[];

  MirthFitlerForm: FormGroup;

  isLoadinghandler: boolean;
  isLoadingcaseid: boolean;
  isLoadinglogid: boolean;
  isLoadingstatusMirth: boolean;
  isLoadingCreatedDate: boolean;
  isLoadingProcessingDate: boolean;
  isadvancefilter: boolean;

  keywordsearchcaseid = "caseid";
  keywordsearchhandler = "handler";
  keywordsearchLogID = "LogId";
  keywordsearchstatusmirth = "status";
  keywordsearchcreatedDate = "createddate";
  keywordsearchprocessingDate = "processingdate";

  notfounddata1: boolean;
  notfounddata2: boolean;
  notfounddata3: boolean;
  notfounddata4: boolean;
  notfounddata5: boolean;


  SuccessMessageList: any[] = [];
  CreatedMessageList: any[] = [];
  failureMessageList: any[] = [];
  AutohealingMessageList: any[] = [];
  ProcessingMessageList: any[] = [];
  IgnoreMessageList: any[] = [];
  OtherMessageList: any[] = [];

  isContainsMultiplefileid: boolean;
  messageiotreprocess: boolean;
  downloadbuttonenable: boolean = true;
  backupinputdata: any;
  msgObjforiot: any;
  today = new Date();
  isEngine: any = "HUB";
  isFormView: boolean;
  selectedIndexTab: any = 0;
  mirthStatusList = [
    { displayname: "All" },
    { displayname: "New" },
    { displayname: "Success" },
    { displayname: "Failure" },
    { displayname: "Processing" },
    { displayname: "Ignore" },
    { displayname: "Others" },
  ];
  selecteditemscount: any;
  showSourceTarget: boolean = true;
  isLoadingentity: boolean = false;
  EntityNameList = <any>[];
  selectedEntityguid: string = "";
  selectedEntityName: string = "";
  messageMirthList: any[];
  messagestageMirthList: any[];
  totalmessagecountMirth: any;
  invalidlogID: boolean;
  invalidcaseid: boolean;
  isvalidSPLchar: boolean;
  reactiveFormparentmessageid: FormGroup;
  backupcase360message: any;
  pagenumber: number = 1;
  PageSize = 100;
  pageEvent: PageEvent;
  exportBatchSize = 500;
  exportBatchIndex = 0;
  exportDynamicColumnKeys: Set<string> = new Set();
  messagesExportMenuOpen = false;
  // Bulk Image-2 section (pills + Download ZIP) expanded inside Export menu after "Bulk file download" row click.
  bulkDownloadSectionOpen = false;

  // --- Bulk file download (new; does not alter existing export / single-file download) ---
  bulkDownloadMaxMessages = 10;
  bulkDownloadIncludeInput = false;
  bulkDownloadIncludeTransformed = false;
  bulkDownloadBothChecked = false;
  bulkDownloadInProgress = false;
  // Message count shown in the progress banner while the sync ZIP request is in flight.
  bulkDownloadProcessingCount = 0;
  bulkDownloadPendingSelector: any = null;
  bulkDownloadPendingMessageList: any[] = [];
  messagesExportMenuStyle: { top: string; left: string } = { top: '0px', left: '0px' };
  exportMenuSelector: any;

  selectedsourcetypeName: string = "";
  selectedsourcedeploymentkey: string = "";
  selectedtargettypeName: string = "";
  selectedtargetdeploymentkey: string = "";
  selectedEntityType: string = "";
  selectedEntityDeploymentkey: string = "";
  toastMessageShown: boolean = false;
  isEllipsisVisible: boolean = false;

  messageNote: string = "";
  messageSelector = <any>[];
  messageindenty: string = "";

  reactiveFormmessageattribute: FormGroup;
  messageattributeslist = <any>[];
  filteredMessageAttributesList = <any>[];
  uniqueid: any;
  selectedMessage: any;
  selectedStageData: any;
  selectedInput: any;
  selectedOutput: any;
  messageAttributesList: any[] = [];
  displayedReferences = new Set<string>();
  FileId: any;
  messagereferenceid: any;
  servicessostatussub: Subscription;
  backupfileArray: any[] = [];
  dataExtractRouteName: string = "";
  CsvDataExtract = <any>[];
  // isExpanded: boolean = false;
  Parentmessageid: any;
  ParentUniqueid: any;
  ParentRouteid: any;
  Parentroutename: any;
  copyinput: string =
    '<Case AccessionNumber="DM24-000031" CaseComments="" CaseGUID="4117054A-F54F-414D-B7E4-303B439308DB" CaseProfileName="" CaseRejectionNotes="" CaseType="GI Histology_PLUS" CaseTypeDisplayName="GI Histology" CaseXMLVersion="2.1" CopyReport="0" DemographyStatus="Completed" DisclaimerValue="" Encounter="" Fasting="" GleasonScore="" HighRiskCase="false" InternalNotes="[ Cybill Guregyan, 01/06/24 - 10:16 ] &lt;span style=&quot;font-family: Roboto;&quot;&gt;Audited&lt;/span&gt;" IsAbnormal="" IsRepeated="" IsTestCase="0" LmpDate="" ObservationAndQuantitationComments="" OrderCode="GIHist" OrderNo="" ProcessingDate="" ProcessingNotes="" ResultStatus="Final" Ruleouts="" SendOut="No" SendOutDate="" SendOutNotes="" SendOutServices="" SendOutWork="Not Applicable" Services="Technical Only" SpecialInstructions="special indications/rule out: microscopic colitis, gastritis/H. pylori" Stage="Diagnosis" Status="Finalized" TechKitLotNumber="" VisitNumber="" clienttrackingnumber="" orderno="">';

  encryptedurl: any = "";
  encryptflag: boolean = false;
  stageData: any;
  servicesso: boolean= false;
  fromdate: any;
  todate: any;
  totalmessagecount: number = 0;
  displayedColumns: string[] = [
    "messagetype",
    "messageid",
    "transactionid",
    "createddate",
    "options",
  ];
  transactionidvalue: string = "";
  InputData: any;
  InputDatabackup:any;
  OutputData: any;
  OutputDatabackup:any;
  OutputJson: string;
  OutputJsonResponsebody: string;
  fileidValue: string;
  filecontents: any;
  InputDataJson: any[];
  transId: string;
  hash: string;
  senderid: string;
  filecheck: boolean = false;
  displaystage: string = "";
  fileidslist: any = [];
  fileidslisttodownload: any = [];
  stageid: string = "";
  inputmediatypedisplay: boolean = true;
  outputmediatypedisplay: boolean = true;
  messageuniqueid: number = 0;
  messagetypefiledownload: string = "";
  
  messageStatusList: any = [];
    sourcearray: any[];
  destinationarray: any[];
  processorarray: any[];
  MessageTraceData = <any>[];
  displaymessageid: string = "";
    reprocessbtn: boolean;
  releasebtn: boolean = false;
  dataview: boolean = false;

  selection = new SelectionModel<any>(true, []);

  checkeddata: any = [];
  messagereprocessdata: any = [];

  transactionid: any = [];
  senderagentid: any = [];

  fileidOutputValue: any;
  fileidInputValue: any;
  fileInputcheck: boolean;

  outputfilecontent: any;
  inputfilecontent: any;
  mediatypedisplay: boolean = true;
  formatType: string = "xml";
  inputFormatType: string = 'xml';
  outputFormatType: string = 'xml';
  editorOptions = {
    theme: 'vs', language: this.formatType, readOnly: true, wordWrap: 'on', scrollBeyondLastLine: false
  };
  userrole: string = "";
  pagerolepermisions: any = [];
  isSearched: boolean = false;
  inputdata: any = {};
  inputhl7data: any
  msgsubtab:any;
  msgredirectdata:any;
  
  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'messages';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];
  private modalRefsTracked: Array<{ ref: any, windowClass: string }> = [];

  private trackModalRef(modalRef: any, windowClass: string = '') {
    this.currentModalRefs.push(modalRef);
    this.modalRefsTracked.push({ ref: modalRef, windowClass });
  }

  private untrackModalRef(modalRef: any) {
    this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    this.modalRefsTracked = this.modalRefsTracked.filter(m => m.ref !== modalRef);
  }
  
  constructor(
    private router: Router,
    private service: CommonService,
    private _fb: FormBuilder,
    private modalService: NgbModal,
    private ngxUiLoaderService: NgxUiLoaderService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private activeModal: NgbActiveModal,
    private datePipe: DatePipe,
    private loginService: LoginService,
    public dialog: MatDialog,
    private tabChangeService: TabChangeService,
    private cdr: ChangeDetectorRef
  ) {
    this.getProcessorName("pipeline");
    this.reactiveFormsource = _fb.group({ name: "" });
    this.reactiveFormroute = _fb.group({ routename: "" });
    this.reactiveFormtarget = _fb.group({ namet: "" });
    this.reactiveFormprocess = _fb.group({ namep: "" });
    this.reactiveFormmessageid = _fb.group({ namemessageid: "" });
    this.reactiveFortransactionid = _fb.group({ nametransactionid: "" });
    this.reactiveForentityfield = _fb.group({ nameentityfieldid: "" });
    this.reactiveFormmsgtype = this._fb.group({ msgname: "" });
    this.reactiveFormmsgstatus = this._fb.group({ msgstatusname: "" });
    this.reactiveFormentity = this._fb.group({ entityname: "" });
    this.reactiveFormparentmessageid = this._fb.group({ parentmsgid: "" });

    this.route.queryParams.subscribe(async (params) => {
      if (params.Input != undefined && params.Input != "") {
        this.encryptedurl = params.Input;
        this.encryptflag = true;
        this.service.updatessoStatus(true);
        await this.GetDisplayNameByEncrypt(params.Input)
      }
    });
  }


  ngOnChanges() {
    this.messageList = this.messageData;
    if (this.case360 != null || this.case360 != undefined) {
      if (this.case360.routeid !== undefined) {
        this.selectedrouteId = this.case360.routeid;
        this.transactionidvalue = this.case360.transaction;
        this.SearchMessages(false);
      } else {
        this.rolepermission();
        this.messageList = JSON.parse(
          JSON.stringify(this.case360.hubmessagedata)
        );
        this.getMessagestatuslist("msgstatus");
      }
    }
  }
  showallcaseinboundmessage() {
    this.isSearched = true;
    this.isEngine = "HUB";
    this.messageFullData = this.messageStatusAllList;
    this.messageFullData.forEach(ele => {
      ele.selector = new SelectionModel<any>(true, []);
    });
    this.backupcase360message = JSON.parse(
      JSON.stringify(this.case360.hubmessagedata)
    );
    this.messageFullData[this.selectedIndexTab].messageList = JSON.parse(
      JSON.stringify(this.case360.hubmessagedata)
    );
    this.messageFullData[
      this.selectedIndexTab
    ].messagestageList = this.case360.hubmessagestage;
    this.messageFullData[
      this.selectedIndexTab
    ].totalmessagecount = this.case360.hubmessagedata.length;
  }

   ngOnInit() {
    this.servicessostatussub = this.service.servicessostatus.subscribe((data) => {
      if (data) {
        this.servicesso = true;
      } else {
        this.servicesso = false;
      }
    });
    this.msgsubtab=this.service.message$.subscribe((data:any)=>{
      this.reset();
      this.inputdata =data;
      this.msgredirectdata=data;
      this.getSetMsgData();
    });
    
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });

    this.service.timezoneChanged$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.cdr.markForCheck();
    });

    // Sync bulk-download in-progress flag from root service (survives navigation; toast is global).
    this.service.bulkDownloadRunning$.pipe(takeUntil(this.destroy$)).subscribe((running) => {
      this.bulkDownloadInProgress = running;
      if (!running) {
        this.bulkDownloadProcessingCount = 0;
      }
    });
    
    if(this.msgredirectdata==undefined ||this.msgredirectdata==null || this.msgredirectdata=='')
    {
      this.getSetMsgData();
  }
  }
  async getSetMsgData(){
    this.setDateFilter()
    this.inputdata = JSON.parse(sessionStorage.getItem('hubmessagedata'));
    if (this.inputdata != '' && this.inputdata != null) {
      sessionStorage.removeItem('hubmessagedata');
      this.selectedrouteId = this.inputdata['id'];
      this.selectedrouteId != '' ? this.getRouteNames(this.selectedrouteId) : '';
      if (this.inputdata['status']) {
        this.selectedmessagestatustype = this.inputdata['status'];

        this.reactiveFormmsgstatus.patchValue({
          msgstatusname: this.selectedmessagestatustype
        });
        const filterDate = this.inputdata['dayFilter'] === 'yesterday'
          ? this.getPreviousDay(new Date())
          : new Date();
        const formattedDate = this.datePipe.transform(filterDate, 'yyyy-MM-dd');
        this.fromdate = formattedDate;
        this.todate = formattedDate;
      }
      // Handle pinnedonly filter from redirect
      if (this.inputdata['pinnedonly']) {
        this.pinnedcheck = true;
        // Clear date filter to show all pinned messages regardless of date
        this.fromdate = '';
        this.todate = '';
      }
      this.getMessagestatuslist("msgstatus");

      // this.getRouteDetails();
      setTimeout(() => {
        this.SearchMessages(false);
      }, 1000);
    }
    this.MirthFitlerForm = this._fb.group({
      handler: "",
      LogId: "",
      caseid: "",
      status: "",
      createddate: "",
      processingdate: "",
      deployment: "",
    });

    // this.messageList = this.messageData.data;
    if (this.service.messagesData !== "") {
      this.messageData = JSON.parse(this.service.messagesData);
      this.isFormView = true;
      this.isEngine = this.messageData["engine"];
      if (this.isEngine === "HUB") {
        this.reactiveFormroute.patchValue({
          routename: this.messageData["name"],
        });
        this.selectedrouteId = this.messageData["name"];
        this.SearchMessages(false);
      } else {
        this.messageFullData = JSON.parse(JSON.stringify(this.mirthStatusList));

        this.messageFullData.forEach(ele => {
          ele.selector = new SelectionModel<any>(true, []);
        });
        this.MirthFitlerForm.patchValue({
          handler: this.messageData.name,
        });
        this.messageFullData[
          this.selectedIndexTab
        ].messageList = this.messageData.MessageDetails;
        this.messageFullData[
          this.selectedIndexTab
        ].totalmessagecount = this.messageData.MessageDetails.length;
        this.isEngine = this.messageData["engine"];
        this.reactiveFormroute.patchValue({
          routename: this.messageData["name"],
        });
        return;
      }
    }
    this.screenHeight = window.innerHeight;
    if ((await this.service.checksession()) == true) {
      this.rolepermission();
      this.isAddedForReprocess = false;
      this.getMessagetypelist("msgtype");
      this.reactiveFormmsgtype.patchValue(this.messageTypeAllList);
      this.getMessagestatuslist("msgstatus");
      this.reactiveFormmsgstatus.patchValue(this.messageStatusAllList);
    }
  }

  rolepermission() {
    const value = sessionStorage.getItem("rolewithmenus");
    if (value) {
      const menuid = JSON.parse(sessionStorage.getItem("rolewithmenus"))
        .find(x => x.RoleName == sessionStorage.getItem("SelectedUserRole"))
        .menuslist.find(y => y.MenuDisplayName == "MESSAGES").MenuId;
      const actionitems = JSON.parse(sessionStorage.getItem("rolewithmenus"))
        .find(x => x.RoleName == sessionStorage.getItem("SelectedUserRole"))
        .menuslist.filter(y => y.ParentMenuId == menuid);
      actionitems.forEach(element => {
        this.pagerolepermisions[element.MenuName] = true;
      });
    }
  }
  ngAfterViewInit() {
    if (this.case360 != null || this.case360 != undefined) {
      this.fromdate = "";
      this.todate = "";
    }
  }
  setDateFilter() {
    var curr = new Date(); // get current date
    var first = curr.getDay(); // First day is the day of the month - the day of the week
    var last = curr.getDate(); // last day is the first day + 6
    first = last - curr.getDay();
    ////console.log(curr, first, last);
    first = last - 6;
    let firstday = new Date(curr.setDate(first));
    let lastd = new Date();
    let lastday = new Date(lastd.setDate(last));
    let firstdate, lastdate, firstmonth, lastmonth;
    firstmonth =
      firstday.getMonth() + 1 < 10
        ? "0" + (firstday.getMonth() + 1)
        : firstday.getMonth() + 1;
    lastmonth =
      lastday.getMonth() + 1 < 10
        ? "0" + (lastday.getMonth() + 1)
        : lastday.getMonth() + 1;
    firstdate =
      firstday.getDate() < 10 ? "0" + firstday.getDate() : firstday.getDate();
    lastdate =
      lastday.getDate() < 10 ? "0" + lastday.getDate() : lastday.getDate();

    this.fromdate = `${firstday.getFullYear()}-${firstmonth}-${firstdate}`;
    // this.todate = `${firstday.getFullYear()}-${firstmonth}-${firstdate}`;
    this.todate = `${lastday.getFullYear()}-${lastmonth}-${lastdate}`;

    ////console.log(this.datefilter,this.enddtfilter)
  }
  // CreatedMessageList
  FilterCreatedMessage() {
    let createmessge = this.messageList.filter(va =>
      va.status === "New" ? "progress_card" : ""
    );
    this.getmirthListData(createmessge);
  }

  isAllSelectedCreated() {
    const numSelected = this.createdSelection.selected.length;
    const numRows = this.CreatedMessageList.length;
    return numSelected === numRows;
  }

  createdSelection = new SelectionModel<any>(true, []);
  createdreprocess() {
    if (this.isEngine !== "HUB") {
      this.mirthReprocessSelected(this.createdSelection.selected, "Created");
    } else {
      this.reprocessSelected(this.createdSelection.selected, "Created", "");
    }
  }

  masterToggleCreated() {
    this.isAllSelectedCreated()
      ? this.createdSelection.clear()
      : this.CreatedMessageList.forEach(row =>
        this.createdSelection.select(row)
      );
  }
  //----------------------------------------------------------------------------

  // SuccessMessageList
  FilterSuccessMessage() {
    if (this.messageData.MessageDetails.length > 0) {
      let successlist = this.messageData.MessageDetails.filter(
        va =>
          va.status === "11" ||
          va.status.toLowerCase() === "success" ||
          va.status.toLowerCase() === "generated" ||
          va.status.toLowerCase() === "generated-warnings" ||
          va.status.toLowerCase() === "generated with warnings" ||
          va.status.toLowerCase() === "processed" ||
          va.status.toLowerCase() === "processed-warnings" ||
          va.status.toLowerCase() === "attached" ||
          va.status.toLowerCase() === "order complete" ||
          va.status.toLowerCase() === "re-directed" ||
          va.status.toLowerCase() === "requisition attached" ||
          va.status.toLowerCase() === "requisition-processed" ||
          va.status.toLowerCase() === "adt complete" ||
          va.status.toLowerCase() === "adt processed with warning"
      );
      this.getmirthListData(successlist);
    } else {
      {
        this.getmirthListData([]);
      }
    }
  }

  filterdata360(status, index) {
    this.messageFullData.forEach(ele => {
      ele.selector = new SelectionModel<any>(true, []);
    });
    switch (status) {
      case "completed":
        this.messageFullData[
          index
        ].messageList = this.backupcase360message.filter(
          va => va.status == "11"
        );
        this.messageFullData[
          index
        ].messagestageList = this.case360.hubmessagestage;
        this.messageFullData[
          this.selectedIndexTab
        ].totalmessagecount = this.messageFullData[index].messageList.length;
        break;
      case "created":
        this.messageFullData[
          index
        ].messageList = this.backupcase360message.filter(
          va => va.status == "10"
        );
        this.messageFullData[
          index
        ].messagestageList = this.case360.hubmessagestage;
        this.messageFullData[
          this.selectedIndexTab
        ].totalmessagecount = this.messageFullData[index].messageList.length;
        break;
      case "failed":
        this.messageFullData[
          index
        ].messageList = this.backupcase360message.filter(
          va => va.status == "12"
        );
        this.messageFullData[
          index
        ].messagestageList = this.case360.hubmessagestage;
        this.messageFullData[
          this.selectedIndexTab
        ].totalmessagecount = this.messageFullData[index].messageList.length;

        break;
      case "autoHealing":
        this.messageFullData[
          index
        ].messageList = this.backupcase360message.filter(
          va => va.status == "15"
        );
        this.messageFullData[
          index
        ].messagestageList = this.case360.hubmessagestage;
        this.messageFullData[
          this.selectedIndexTab
        ].totalmessagecount = this.messageFullData[index].messageList.length;

        break;
      case "resolved":
        this.messageFullData[
          index
        ].messageList = this.backupcase360message.filter(
          va => va.status == "13"
        );
        this.messageFullData[
          index
        ].messagestageList = this.case360.hubmessagestage;
        this.messageFullData[
          this.selectedIndexTab
        ].totalmessagecount = this.messageFullData[index].messageList.length;

        break;
      case "ignored":
        this.messageFullData[
          index
        ].messageList = this.backupcase360message.filter(
          va => va.status == "14"
        );
        this.messageFullData[
          index
        ].messagestageList = this.case360.hubmessagestage;
        this.messageFullData[
          this.selectedIndexTab
        ].totalmessagecount = this.messageFullData[index].messageList.length;

        break;
      case "in progress":
        this.messageFullData[
          index
        ].messageList = this.backupcase360message.filter(
          va => va.status == "25"
        );
        this.messageFullData[
          index
        ].messagestageList = this.case360.hubmessagestage;
        this.messageFullData[
          this.selectedIndexTab
        ].totalmessagecount = this.messageFullData[index].messageList.length;

        break;
      default:
        this.messageFullData[index].messageList = this.backupcase360message;
        this.messageFullData[
          index
        ].messagestageList = this.case360.hubmessagestage;
        this.messageFullData[
          this.selectedIndexTab
        ].totalmessagecount = this.messageFullData[index].messageList.length;

        break;
    }
  }

  isAllSelectedSuccess() {
    const numSelected = this.successSelection.selected.length;
    const numRows = this.SuccessMessageList.length;
    return numSelected === numRows;
  }

  successSelection = new SelectionModel<any>(true, []);
  successreprocess() {
    if (this.isEngine !== "HUB") {
      this.mirthReprocessSelected(this.successSelection.selected, "Success");
    } else {
      this.reprocessSelected(this.successSelection.selected, "Success", "");
    }
  }
  masterToggleSuccess() {
    this.isAllSelectedSuccess()
      ? this.successSelection.clear()
      : this.SuccessMessageList.forEach(row =>
        this.successSelection.select(row)
      );
  }
  //----------------------------------------------------------------------------

  // FailureMessageList
  FilterFailureMessage() {
    let failuremessage = this.messageData.MessageDetails.filter(
      va =>
        va.status === "12" ||
        va.status.toLowerCase() === "failed" ||
        va.status.toLowerCase() === "failure" ||
        va.status.toLowerCase() === "error" ||
        va.status.toLowerCase() === "order failed" ||
        va.status.toLowerCase() === "failed to parse" ||
        va.status.toLowerCase() === "message api failure" ||
        va.status.toLowerCase() === "requisition failed" ||
        va.status.toLowerCase() === "adt failed"
    );
    this.getmirthListData(failuremessage);
  }

  isAllSelectedFailure() {
    const numSelected = this.failureSelection.selected.length;
    const numRows = this.failureMessageList.length;
    return numSelected === numRows;
  }

  failureSelection = new SelectionModel<any>(true, []);
  failurereprocess() {
    if (this.isEngine !== "HUB") {
      this.mirthReprocessSelected(this.failureSelection.selected, "Failure");
    } else {
      this.reprocessSelected(this.failureSelection.selected, "Failure", "");
    }
  }

  masterTogglefailure() {
    this.isAllSelectedFailure()
      ? this.failureSelection.clear()
      : this.failureMessageList.forEach(row =>
        this.failureSelection.select(row)
      );
  }
  //----------------------------------------------------------------------------

  // AutoHealingMessageList
  FilterAutohealingMessage() {
    this.AutohealingMessageList = this.messageList.filter(
      va => va.status === "15"
    );
  }

  isAllSelectedAutohealing() {
    const numSelected = this.AutohealingSelection.selected.length;
    const numRows = this.AutohealingMessageList.length;
    return numSelected === numRows;
  }

  AutohealingSelection = new SelectionModel<any>(true, []);
  Autohealingreprocess() {
    if (this.isEngine !== "HUB") {
      this.mirthReprocessSelected(
        this.AutohealingSelection.selected,
        "Auto-Healing"
      );
    } else {
      this.reprocessSelected(
        this.AutohealingSelection.selected,
        "Auto-Healing",
        ""
      );
    }
  }

  masterToggleAutohealing() {
    this.isAllSelectedAutohealing()
      ? this.AutohealingSelection.clear()
      : this.AutohealingMessageList.forEach(row =>
        this.AutohealingSelection.select(row)
      );
  }
  //----------------------------------------------------------------------------

  // ProcessingMessageList
  FilterProcessingMessage() {
    let processlist = this.messageData.MessageDetails.filter(
      va =>
        va.status.toLowerCase() === "message posted" ||
        va.status.toLowerCase() === "processing" ||
        va.status.toLowerCase() === "waiting"
    );
    this.getmirthListData(processlist);
  }

  isAllSelectedProcessing() {
    const numSelected = this.ProcessingSelection.selected.length;
    const numRows = this.ProcessingMessageList.length;
    return numSelected === numRows;
  }

  ProcessingSelection = new SelectionModel<any>(true, []);
  Processingreprocess() {
    if (this.isEngine !== "HUB") {
      this.mirthReprocessSelected(
        this.ProcessingSelection.selected,
        "Processing"
      );
    } else {
      this.reprocessSelected(
        this.ProcessingSelection.selected,
        "Processing",
        ""
      );
    }
  }

  masterToggleProcessing() {
    this.isAllSelectedProcessing()
      ? this.ProcessingSelection.clear()
      : this.ProcessingMessageList.forEach(row =>
        this.ProcessingSelection.select(row)
      );
  }
  //----------------------------------------------------------------------------

  // IgnoreMessageList
  FilterIgnoreMessage() {
    let ignorelist = this.messageData.MessageDetails.filter(
      va =>
        va.status.toLowerCase() === "ignore" ||
        va.status.toLowerCase() === "ignored" ||
        va.status.toLowerCase() === "skipped" ||
        va.status.toLowerCase() === "nobarcodescanned" ||
        va.status.toLowerCase() === "requisition ignored" ||
        va.status.toLowerCase() === "adt ignored" ||
        va.status.toLowerCase() === "invalid"
    );
    this.getmirthListData(ignorelist);
  }

  isAllSelectedIgnore() {
    const numSelected = this.IgnoreSelection.selected.length;
    const numRows = this.IgnoreMessageList.length;
    return numSelected === numRows;
  }

  IgnoreSelection = new SelectionModel<any>(true, []);
  Ignorereprocess() {
    if (this.isEngine !== "HUB") {
      this.mirthReprocessSelected(this.IgnoreSelection.selected, "Ignored");
    } else {
      this.reprocessSelected(this.IgnoreSelection.selected, "Ignored", "");
    }
  }

  masterToggleIgnore() {
    this.isAllSelectedIgnore()
      ? this.IgnoreSelection.clear()
      : this.IgnoreMessageList.forEach(row => this.IgnoreSelection.select(row));
  }
  //----------------------------------------------------------------------------

  // OtherMessageList
  FilterOtherMessage() {
    let otherlist = this.messageData.MessageDetails.filter(
      va =>
        va.status.toLowerCase() === "test" ||
        va.status.toLowerCase() === "bulkfile"
    );
    this.getmirthListData(otherlist);
  }

  isAllSelectedOther() {
    const numSelected = this.OtherSelection.selected.length;
    const numRows = this.OtherMessageList.length;
    return numSelected === numRows;
  }

  OtherSelection = new SelectionModel<any>(true, []);
  Otherreprocess() {
    if (this.isEngine !== "HUB") {
      this.mirthReprocessSelected(this.OtherSelection.selected, "Others");
    } else {
      this.reprocessSelected(this.OtherSelection.selected, "Others", "");
    }
  }

  masterToggleOther() {
    this.isAllSelectedOther()
      ? this.OtherSelection.clear()
      : this.OtherMessageList.forEach(row => this.OtherSelection.select(row));
  }
  //----------------------------------------------------------------------------

  fileids: string = "";
  filename: string = "";
  selectedroutedefinitionid: string = "";
  ischild:boolean;
  getmessage_iot(value, modalmessageiot,ischild) {
    this.ischild=ischild;
    this.messageuniqueid = value.id;
    this.ngxUiLoaderService.start();
    this.msgObjforiot = value;
    this.service
      .Hubmessage_IOTData(this.msgObjforiot["id"], this.msgObjforiot["fileid"], this.arhivecheckbackup)
      .subscribe(
        async data => {
          if (data) {
            await this.processIotMessageData(data);
            this.ngxUiLoaderService.stop();
            this.openIotModal(modalmessageiot);
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
          this.service.copyableToastError(error.statusText);
        }
      );
  }

  private normalizeHL7InputData(inputData: string): string {
    if (inputData == null) {
      return inputData;
    }
    return inputData.replace(/\r/g, "[tempData]").replace(/\n/g, "[tempData1]");
  }

  private formatData(data: string): string {
    if (!data) {
      return data;
    }
    if (this.service.IsJsonString(data)) {
      return JSON.stringify(JSON.parse(data), null, 2);
    }
    if (this.IsValidXML(data)) {
      return beautify(data);
    }
    return data;
  }

  private processInputData(inputData: string): string {
    return this.formatData(inputData);
  }

  private processTransformedData(transformedData: string): { formatted: string; fileIdArray: any[] } {
    if (!transformedData) {
      return { formatted: transformedData, fileIdArray: [] };
    }
    if (this.service.IsJsonString(transformedData)) {
      const transformparse = JSON.parse(transformedData);
      return {
        formatted: JSON.stringify(transformparse, null, 2),
        fileIdArray: transformparse
      };
    }
    if (this.IsValidXML(transformedData)) {
      return {
        formatted: beautify(transformedData),
        fileIdArray: []
      };
    }
    return { formatted: transformedData, fileIdArray: [] };
  }

  private async processAcknowledgedStages(acknowledgedStages: any): Promise<void> {

    if (!acknowledgedStages || typeof acknowledgedStages === 'string') {
      return;
    }
    
    if (!Array.isArray(acknowledgedStages) || acknowledgedStages.length === 0) {
      return;
    }
    
    await Promise.all(acknowledgedStages.map(async obj => {
      const result = await parseFlattenToPairs(obj.Data || obj);
      obj['Databackup'] = obj.Data || obj;
      obj['isstring'] = result.length === 0;
      if(obj.Data==undefined || obj.Data==null){
        obj = result.length > 0 ? result : obj;
      }
      else{
        obj.Data = result.length > 0 ? result : obj.Data;
      }
    }));
  }

  private async processIotMessageData(data: any): Promise<void> {
    this.message_iot_data = data;
    this.inputhl7data = { ...data };

    // Keep unformatted API payloads for copy so XML entities (e.g. &amp;) are preserved.
    this.message_iot_data["InputDataRaw"] = this.message_iot_data["InputData"] ?? "";
    this.message_iot_data["TransformedDataRaw"] =
      this.message_iot_data["TransformedData"] ?? "";

    if (this.inputhl7data["InputData"] != null) {
      this.inputhl7data["InputData"] = this.normalizeHL7InputData(this.inputhl7data["InputData"]);
    }

    this.message_iot_data["title"] = this.msgObjforiot["messageid"];
    
    if (this.message_iot_data["InputData"]) {
      this.message_iot_data["InputData"] = this.processInputData(this.message_iot_data["InputData"]);
      this.editorInit(this.message_iot_data["InputData"], null, 'input');
    }

    if (this.message_iot_data["TransformedData"]) {
      const transformedResult = this.processTransformedData(this.message_iot_data["TransformedData"]);
      this.message_iot_data["TransformedData"] = transformedResult.formatted;
      this.fileidarray = transformedResult.fileIdArray;
      this.editorInit(this.message_iot_data["TransformedData"], null, 'output');
    }

    this.downloadbuttonenable = this.service.IsJsonString(this.message_iot_data["TransformedData"]) &&
      this.message_iot_data["TransformedData"] !== null;

    if (this.message_iot_data["Output"]?.['AcknowledgedStage']) {
      await this.processAcknowledgedStages(this.message_iot_data["Output"]['AcknowledgedStage']);
    }
        if (this.message_iot_data["Output"]?.['DeliveredStage']) {
      await this.processAcknowledgedStages(this.message_iot_data["Output"]['DeliveredStage']);
    }
  }

  private openIotModal(modalmessageiot: any): void {
    const iotModalRef = this.modalService
      .open(modalmessageiot, {
        windowClass: "messageiot",
        backdrop: "static",
        keyboard: false,
      });
    
    this.trackModalRef(iotModalRef, "messageiot");
    this.adjustModalHeight("messageiot");
    
    iotModalRef.result.then(
      (result) => { 
        this.modalWasOpen = false;
        this.untrackModalRef(iotModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.untrackModalRef(iotModalRef);
      }
    );
    
    // Add data attribute to identify the modal
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.messageiot') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-hubmessages-modal', 'true');
      }
    }, 0);
    
    this.modalWasOpen = true;
  }
  selectedRoute(item) {
    this.selectedrouteId = item.id;
    this.selectedrouteDisplayName = item.displayname;
    this.SearchMessages(false);
  }

  /* download changes start*/
  downloadfilebyFileid(isflag, modalpopup) {
    this.ngxUiLoaderService.start();
    if (this.fileidarray.length > 0) {
      this.backupfileArray = [];
      for (var i = 0; i < this.fileidarray.length; i++) {
        this.downloadcontents(
          this.fileidarray[i].fileid,
          this.fileidarray[i].filename,
          isflag,
          modalpopup, ""
        );
      }
    } else {
      //this.downloadcontents(fileId);
    }
    //this.ngxUiLoaderService.stop();
  }

  downloadcontents(fileids, filename, isflag, modalpopup, messageId) {
    let jsondata = {
      messagetype: this.messagetypefiledownload,
      fileid: fileids,
      contextId: this.messageuniqueid,
      createdBy: JSON.parse(sessionStorage.getItem("sessionObjectlogin"))
        .userdata["userid"],
    };
    this.ngxUiLoaderService.start();

    this.service.GetFileContentByFileID(jsondata).subscribe((response: any) => {
      if (response.length > 0) {
        this.backupfileArray = response.concat(this.backupfileArray);
        if (
          this.fileidarray.length == 1 &&
          response.length == 1 &&
          isflag == "view"
        ) {
          response[0].filename = filename;
          this.viewFile(response[0]);
        } else if (
          this.fileidarray.length === this.backupfileArray.length &&
          isflag == "view"
        ) {
          this.fileidarray.forEach(element => {
            let uniq = this.backupfileArray.find(
              va => va.fileid == element.fileid
            );
            uniq.filename = element.filename;
          });
          const modalRef = this.modalService.open(ConsolidateviewfileComponent, {
            windowClass: "PopupScreen",
            backdrop: "static",
            keyboard: false,
          });
          modalRef.componentInstance.backupfileArray = this.backupfileArray;
          this.adjustModalHeight("PopupScreen");
          modalRef.result.then(() => { });
        } else if (isflag == "download") {
          response.forEach(element => {
            if (element.filecontent != null) {
              filename = filename === "" ? (this.InputData?.["inputfilename"] || "") : filename;
              // if (filename == "") {
              //   filename = element.fileid + element.fileformat;
              // }
              this.ngxUiLoaderService.stop();
              this.downloadFiles(element, filename, messageId);
            } else {
              this.ngxUiLoaderService.stop();
            }
          });
        }
        this.ngxUiLoaderService.stop();
      }
      else {
        if (!this.toastMessageShown) {
          this.toastr.error('Download Failed, File Not Found', "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
          this.toastMessageShown = true;
        }
        this.ngxUiLoaderService.stop();
      }
    });
  }
  selectFile(response) {
    this.viewFile(response);
  }
  downloadFiles(data: any, filename: any, messageId: any) {
    if (filename == null || filename == '') {
      filename = messageId || this.displaymessageid;
    }
    if (!filename.includes(".")) {
      filename = filename + "." + data.fileformat;
    }
    var decodedContent = null;
    if (data.fileformat == "pdf") {
      this.ngxUiLoaderService.start();
      decodedContent = "data:application/pdf;base64," + data.filecontent;
      const link = document.createElement("a");
      link.href = decodedContent;
      link.download = filename;
      link.click();
      this.ngxUiLoaderService.stop();
    } else if (data.fileformat !== null) {
      this.ngxUiLoaderService.start();
      decodedContent = data.filecontent;
      let contype = "application/octet-stream";
      const file = new window.Blob([decodedContent], { type: contype });
      const downloadAncher = document.createElement("a");
      const fileURL = URL.createObjectURL(file);
      downloadAncher.href = fileURL;
      downloadAncher.download = filename;
      downloadAncher.click();
      this.ngxUiLoaderService.stop();
    }
  }
  /* download changes end*/

  getRouteNames(event: any) {
    var val = event;
    if (val) {
      this.isLoadingroutes = true;
      var apiname = "api/Routes/GetByDisplayName?name=" + val + "&version=0";
      this.service.getapiurl(apiname).subscribe({
        next: data => {
          this.RouteNameList = data as any[];
          this.RouteNameList.map(obj => obj.displayname = `${obj.displayname}  ${'(' + obj.id + ')(VA-'+obj.UniqueID+')'}`);
          this.isLoadingroutes = false;
          if (this.RouteNameList.length == 1 && this.inputdata != '') {
            this.reactiveFormroute.patchValue({
              routename: this.RouteNameList[0]['displayname']
            });
          }
          if (data.length == 0) {
            this.notfounddata = true;
          }
          else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingroutes = false;
          this.notfounddata = true;
        },
      });
    }
  }
  searchRouteNameCleared(event) {
    this.isLoadingroutes = false;
    this.RouteNameList = [];
    this.selectedrouteId = "";
    this.selectedrouteDisplayName = "";
    this.notfounddata = false;
  }

  sourceCustomFilter = function (
    SourceAccountList: any[],
    query: string
  ): any[] {
    return SourceAccountList;
  };
  keywordaccount = "LocationName";

  async getSourceAccountName(event: any) {
    var valuesa = event;
    let highlightedSource;
    if (event.includes(":")) {
      let splitValues = event.split(":");
      if (splitValues.length === 2) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        event = splitValues.join(":");
      }
      if (splitValues.length === 3) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        splitValues[2] = splitValues[2].trimStart();
        splitValues[2] = " " + splitValues[2];
        event = splitValues.join(":");
      }
    }
    if (highlightedSource != "") {
      highlightedSource = event;
    }
    this.selectedsourceaccountid = "";
    this.reactiveFormsource.patchValue({
      name: event,
    });

    if (valuesa != "" && !valuesa.endsWith(":") && !valuesa.endsWith(": ")) {
      let valueToSendToApiWithOutWhiteSpace = valuesa.replaceAll(": ", ":");
      let obj = {
        lsearch: valueToSendToApiWithOutWhiteSpace,
        LocationGUID: this.selectedtargetaccountid,
        deploymentkey: this.selectedtargetdeploymentkey,
        associatedaccountids: this.selectedtargetassociatedaccountids,
      };
      // var createSearch = "api/SearchAccounts/GetAccountNamesListAsync?lSearch=" + valueToSendToApiWithOutWhiteSpace;

      this.isLoadingsource = true;

      //let response = await this.service.getapi(createSearch);
      this.service.GetAccountNamesListAsync(obj).subscribe((response: any) => {
        if (response["status"] && response["statusText"]) {
          this.SourceAccountList = [];
          this.notfounddata = true;
          this.isLoadingsource = false;
          this.toastr.error("Unable to fetch Source Details", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        } else {
          if (response.length > 0) {
            this.SourceAccountList = response as any[];
            this.SourceAccountList = this.service.transformAlphabetically(
              this.SourceAccountList,
              "LocationName"
            );
            this.SourceAccountList.map(
              obj =>
              (obj.LocationName =
                obj.UniqueID !== null && obj.UniqueID !== undefined
                  ? `${obj.LocationName} ${"(" +
                  obj.LocationGUID +
                  ")"} ${"(" + obj.UniqueID + ")"}`
                  : `${obj.LocationName} ${"(" + obj.LocationGUID + ")"}`)
            );
          }
          if (response.length == 0) {
            this.SourceAccountList = [];
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
          this.selectedsourceaccountid = "";
          this.isLoadingsource = false;
        }
      });
    } else {
      this.SourceAccountList = [];
      this.notfounddata = true;
    }
  }
  getstringRoute(value) {
    let names = value.split("(");
    value = `${names[0]} <br>(${names[1]}`;
    return value;
  }
  getstringpipleline(value) {
    let names = value.split("(")
    value = `${names[0]} <br>(${names[1]} <br>(${names[2]}`
    return value
  }
  locationString(item, item1, item2) {
    let names = item2.split("(");
    item2 =
      names[2] !== "null)" && names[2] !== undefined
        ? `${names[0]} <br> (${names[1]} <br> (${names[2]}`
        : `${names[0]} <br> (${names[1]}`;
    return "(" + item + ")" + " " + item1 + " : " + item2;
  }

  selectedsourceagentEvent(
    item //source agent selected Event
  ) {
    this.selectedsourceaccountid = item.LocationGUID;
    this.selectedsourceaccountName = item.LocationName;
    this.selectedsourceassociatedaccountids = item.associatedaccountids;
    this.selectedsourcetypeName = item.TypeName;
    this.selectedsourcedeploymentkey = item.deploymentkey;
  }

  searchSourceNameCleared(event) {
    this.isLoadingsource = false;
    this.SourceAccountList = [];
    this.selectedsourceaccountid = "";
    this.selectedsourceaccountName = "";
    this.notfounddata = false;
    this.selectedsourcetypeName = "";
    this.selectedsourcedeploymentkey = "";
    this.selectedsourceassociatedaccountids = "";
  }

  searchTargetNameCleared(event) {
    this.isLoadingTarget = false;
    this.TargetAccountList = [];
    this.selectedtargetaccountid = "";
    this.selectedtargetaccountName = "";
    this.notfounddata = false;
    this.selectedtargettypeName = "";
    this.selectedtargetdeploymentkey = "";
    this.selectedtargetassociatedaccountids = "";
  }
  searchProcesorNameCleared(event) {
    this.isLoadingProcesor = false;
    this.ProcessorList = this.ProcessorAllList;
    this.selectedprocessagentid = "";
    this.selectedprocessdisplayname = "";
    this.notfounddata = false;
  }

  targetCustomFilter = function (
    TargetAccountList: any[],
    query: string
  ): any[] {
    return TargetAccountList;
  };

  async getTargetAccountName(event: any) {
    var valueta = event;
    let highlightedTarget;
    if (event.includes(":")) {
      let splitValues = event.split(":");
      if (splitValues.length === 2) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        event = splitValues.join(":");
      }
      if (splitValues.length === 3) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        splitValues[2] = splitValues[2].trimStart();
        splitValues[2] = " " + splitValues[2];
        event = splitValues.join(":");
      }
    }
    if (highlightedTarget != "") {
      highlightedTarget = event;
    }
    this.selectedtargetaccountid = "";
    this.reactiveFormtarget.patchValue({
      namet: event,
    });
    if (valueta != "" && !valueta.endsWith(":") && !valueta.endsWith(": ")) {
      let valueToSendToApiWithOutWhiteSpace = valueta.replaceAll(": ", ":");
      //var createSearch = "api/SearchAccounts/GetAccountNamesListAsync?lSearch=" + valueToSendToApiWithOutWhiteSpace;
      this.isLoadingTarget = true;
      let obj = {
        lsearch: valueToSendToApiWithOutWhiteSpace,
        LocationGUID: this.selectedsourceaccountid,
        deploymentkey: this.selectedsourcedeploymentkey,
        associatedaccountids: this.selectedsourceassociatedaccountids,
      };
      // let response = await this.service.getapi(createSearch);
      this.service.GetAccountNamesListAsync(obj).subscribe((response: any) => {
        if (response["status"] && response["statusText"]) {
          this.TargetAccountList = [];
          this.notfounddata = true;
          this.isLoadingTarget = false;
          this.toastr.error("Unable to fetch Target Details", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        } else {
          if (response.length > 0) {
            this.TargetAccountList = response as any[];
            //this.TargetAccountList=this.service.transformAlphabetically(this.TargetAccountList,'LocationName');
            this.TargetAccountList.map(
              obj =>
              (obj.LocationName =
                obj.UniqueID !== null && obj.UniqueID !== undefined
                  ? `${obj.LocationName} ${"(" +
                  obj.LocationGUID +
                  ")"} ${"(" + obj.UniqueID + ")"}`
                  : `${obj.LocationName} ${"(" + obj.LocationGUID + ")"}`)
            );
          }
          if (response.length == 0) {
            this.TargetAccountList = [];
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
          this.selectedtargetaccountid = "";
          this.isLoadingTarget = false;
        }
      });
    } else {
      this.TargetAccountList = [];
      this.notfounddata = true;
    }
  }
  ProcessorAllList = <any>[];
  async getProcessorName(event: any) {
    this.selectedprocessagentid = "";
    this.isLoadingProcesor = true;
    var apiname = "";
    if (event !== "pipeline") {
      apiname =
        "api/Agents/GetByDisplayName?name=" +
        event +
        "&agentid=0&type=Processor&filterflag=true";
      this.ProcessorList = this.ProcessorAllList.filter(t =>
        t.displayname.toLowerCase().includes(event.toLowerCase()) || t.id === event);
      if (this.ProcessorList.length == 0) {
        this.notfounddata = true;
      } else {
        this.notfounddata = false;
      }
      this.isLoadingProcesor = false;
    } else {
      apiname =
        "api/Agents/GetByDisplayName?name=" +
        "&agentid=0&type=Processor&filterflag=false";

      await this.service.getapiurl(apiname).subscribe({
        next: async data => {
          this.ProcessorList = data as any[];
          this.ProcessorList.map(obj => {
            (obj.name = obj.displayname),
              (obj.displayname = `${obj.displayname}  ${"(" + obj.id + ")"}`);
          });
          if (this.ProcessorList.length > 0) {
            this.ProcessorList = this.service.transformAlphabetically(
              this.ProcessorList,
              "displayname"
            );
          }
          this.ProcessorAllList = this.ProcessorList;
          // this.selectedprocessagentid = '';
          this.isLoadingProcesor = false;
          if (data.length == 0) {
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingProcesor = false;
          this.notfounddata = true;
        },
      });
    }
  }

  selectedtargetagentEvent(
    item //target agent selected Event
  ) {
    this.selectedtargetaccountid = item.LocationGUID;
    this.selectedtargetaccountName = item.locationName;
    this.selectedtargettypeName = item.TypeName;
    this.selectedtargetdeploymentkey = item.deploymentkey;
    this.selectedtargetassociatedaccountids = item.associatedaccountids;
  }

  selectedProcessEvent(item) {
    this.selectedprocessagentid = item.id;
    this.selectedprocessdisplayname = item.displayname;
  }

  isUUID(uuid) {
    let s;

    s = uuid.match(
      "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
    );
    if (s === null) {
      return false;
    }
    return true;
  }


  // check360message(case360){
  //   if( ){
  //   return  'col-md-3 message_btns pt-2 text-center'
  //   }else{
  //     return  'col-md-4 message_btns pt-2 text-center'
  //   }
  // }
  onTabChanged(value) {
    this.isSearched = true;

    this.messageFullData = [];
    this.messageFullData = JSON.parse(JSON.stringify(this.messageStatusList));
    this.messageFullData.forEach(ele => {
      ele.selector = new SelectionModel<any>(true, []);
    });
    setTimeout(() => {
      if (this.paginator != undefined) {
        this.paginator.pageIndex = 0;
      }
    });
    if (value.index !== -1) {
      this.selectedIndexTab = value.index;
      if (
        this.case360 !== undefined &&
        this.case360.hubmessagedata !== undefined &&
        this.case360.hubmessagedata.length > 0
      ) {
        this.filterdata360(
          this.messageStatusList[value.index].displayname,
          value.index
        );
      } else if (
        (this.isEngine == "HUB" && this.case360 == undefined) ||
        this.case360.routeid !== undefined
      ) {
        this.selectedmessagestatustype = this.messageStatusList[
          value.index
        ].displayname;
        this.pagenumber = 1;
        this.SearchMessages(false);
      }
    }
  }

  getmirthListData(value) {
    this.messageFullData[this.selectedIndexTab].messageList = value;
    this.messageFullData[this.selectedIndexTab].totalmessagecount =
      value.length;
  }
  newmsglistexportdata: any = [];
async SearchMessages(isSearchClicked: boolean, pagesize?: number): Promise<any[] | { hubmessagedata: any[]; entitySearches: any[]; hubmessagestage?: any[] }> {
  this.selection.clear();
  this.tablediv = false;
    if (
      this.selectedrouteId == "" &&
      this.reactiveFormroute.get("routename").value != "" &&
      this.reactiveFormroute.get("routename").value != null
    ) {
      let returnvalue = this.isUUID(
        this.reactiveFormroute.get("routename").value
      );
      if (returnvalue == true) {
        this.selectedrouteId = this.reactiveFormroute.get("routename").value;
      } else {
        this.toastr.error("No results found!!", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
        return;
      }
    }
    if (
      this.selectedsourceaccountid == "" &&
      this.reactiveFormsource.get("name").value != "" &&
      this.reactiveFormsource.get("name").value != null
    ) {
      let returnvalue = this.isUUID(this.reactiveFormsource.get("name").value);
      if (returnvalue == true) {
        this.selectedsourceaccountid = this.reactiveFormsource.get(
          "name"
        ).value;
      } else {
        this.toastr.error("No results found!!", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
        return;
      }
    }
    if (
      this.selectedtargetaccountid == "" &&
      this.reactiveFormtarget.get("namet").value != "" &&
      this.reactiveFormtarget.get("namet").value != null
    ) {
      let returnvalue = this.isUUID(this.reactiveFormtarget.get("namet").value);
      if (returnvalue == true) {
        this.selectedtargetaccountid = this.reactiveFormtarget.get(
          "namet"
        ).value;
      } else {
        this.toastr.error("No results found!!", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
        return;
      }
    }
    if (
      this.selectedprocessagentid == "" &&
      this.reactiveFormprocess.get("namep").value != "" &&
      this.reactiveFormprocess.get("namep").value != null
    ) {
      let returnvalue = this.isUUID(
        this.reactiveFormprocess.get("namep").value
      );
      if (returnvalue == true) {
        this.selectedprocessagentid = this.reactiveFormprocess.get(
          "namep"
        ).value;
      } else {
        this.toastr.error("No results found!!", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
        return;
      }
    }
    if (this.fromdate == "" && this.todate == "") {
      this.fromdate = undefined;
      this.todate = undefined;
    }

    if (
      (this.fromdate && !this.todate) ||
      (!this.fromdate && this.todate) ||
      (this.fromdate == "" && this.todate == "")
    ) {
      this.toastr.error("Select From date & To date ", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
      return;
    }
    if (this.fromdate > this.todate) {
      this.toastr.error(
        "From date should be  equal  or  less than To date ",
        "",
        { timeOut: 4000, positionClass: "toast-bottom-right" }
      );
      return;
    }
    let entitykeyvalue = "";
    if (this.msgfieldlist.length > 0) {
      entitykeyvalue = this.msgfieldlist.reduce((acc, current) => {
        acc = acc + current.msgvalue + ",";
        return acc;
      }, "");
      entitykeyvalue = entitykeyvalue.slice(0, -1);
    } else if (
      this.msgfieldctrl.value != "" &&
      this.msgfieldctrl.value != null
    ) {
      this.toastr.warning("Invalid Value in Message Field", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
      return;
    }

    if (
      (this.reactiveFormmessageid.value.namemessageid !== null &&
        this.reactiveFormmessageid.value.namemessageid.trim() !== "") ||
      (this.transactionidvalue !== null && this.transactionidvalue.trim() !== "") ||
      (this.reactiveFormparentmessageid.value.parentmsgid !== null &&
        this.reactiveFormparentmessageid.value.parentmsgid.trim() !== "") ||
      (entitykeyvalue !== null && entitykeyvalue.trim() !== "")
    ) {
      this.fromdate = null;
      this.todate = null;
    }

    if (isSearchClicked) {
      this.pagenumber = 1;
      this.exportDynamicColumnKeys = new Set();
    }
    const effectivePageSize = pagesize || this.PageSize;
    var searchdata = {
      routedefinitionid: this.selectedrouteId,
      sourceentityid: this.selectedsourceaccountid,
      destinationentityid: this.selectedtargetaccountid,
      messagetype: this.selectedmessagetype,
      processoragentid: this.selectedprocessagentid,
      messageid: this.reactiveFormmessageid.get("namemessageid").value,
      transactionid: this.transactionidvalue,
      entitykeyvalue: entitykeyvalue,
      filtermessagestage: this.filtermsgtaggel == true ? "ALL" : "HOLD",
      status:
        this.selectedmessagestatustype == ""
          ? "ALL"
          : this.selectedmessagestatustype,
      archivedbcheck: this.archivedbcheck,
      pinnedonly: this.pinnedcheck,
      FromDate: this.fromdate == undefined ? "" : this.fromdate + " 00:00:00",
      ToDate: this.todate == undefined ? "" : this.todate + " 23:59:59",
      entityid: this.selectedEntityguid,
      parentmessageid: this.reactiveFormparentmessageid.get("parentmsgid")
        .value,
      pagenumber: this.pagenumber,
      pagesize: effectivePageSize,
      SETYPE: this.selectedsourcetypeName,
      SEDEPLOYMENTKEY: this.selectedsourcedeploymentkey,
      DETYPE: this.selectedtargettypeName,
      DEDEPLOYMENTKEY: this.selectedtargetdeploymentkey,
      EETYPE: this.selectedEntityType,
      EEDEPLOYMENTKEY: this.selectedEntityDeploymentkey,
      encryptflag: this.encryptflag,
      encryptedurl: this.encryptedurl
    };
    this.ngxUiLoaderService.start();
    var apiname = "api/HubMessage/GetSearchDetails";
    let response = await this.service.searchpostapi(apiname, searchdata);
      // response => {
        if (response == null) {
          this.ngxUiLoaderService.stop();
          this.arhivecheckbackup = false;
          this.isSearched = false;
          this.messageFullData = [];
          this.toastr.warning(
            "Kindly choose a minimum of one search criteria",
            "Alert",
            {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            }
          );
        } else {
          if (pagesize) {
            return {
              hubmessagedata: response?.hubmessagedata || [],
              entitySearches: response?.entitySearches || [],
              // Stage list from same search response — used by batch export for Failure Reason (no extra API).
              hubmessagestage: response?.hubmessagestage || []
            };
          }
          
          this.ngxUiLoaderService.stop();
          this.isSearched = true;
          this.isEngine = "HUB";
          this.arhivecheckbackup = searchdata.archivedbcheck;
          this.totalmessagecount = 0;
          if (this.selectedIndexTab !== -1) {
            // if(this.pagenumber > 1){
            //
            //   if(this.messageFullData[this.selectedIndexTab].messageList.length>300){
            //     this.messageFullData[this.selectedIndexTab].messageList.splice(0,100)
            //   }
            //   if( this.messageFullData[this.selectedIndexTab].messagestageList.length>300){
            //     this.messageFullData[this.selectedIndexTab].messagestageList.splice(0,100)
            //   }
            //   this.messageFullData[this.selectedIndexTab].messageList =  this.messageFullData[this.selectedIndexTab].messageList.concat(response.hubmessagedata);
            //   this.messageFullData[this.selectedIndexTab].messagestageList = this.messageFullData[this.selectedIndexTab].messagestageList.concat(response.hubmessagestage);
            //   this.messageFullData[this.selectedIndexTab].totalmessagecount = response.messagecount;
            // }
            //else{
            this.messageFullData = JSON.parse(
              JSON.stringify(this.messageStatusList)
            );
            this.selectedIndexTab = this.messageStatusList.findIndex(
              va => va.displayname === this.selectedmessagestatustype
            );
            this.messageFullData.forEach(ele => {
              ele.selector = new SelectionModel<any>(true, []);
            });

            this.messageFullData[
              this.selectedIndexTab
            ].messageList = response.hubmessagedata as any[];
            this.messageFullData[
              this.selectedIndexTab
            ].messagestageList = response.hubmessagestage as any[];
            this.messageFullData[this.selectedIndexTab].totalmessagecount =
              response.messagecount;
            //}
            // Initialize empty child arrays - children will be loaded on-demand when user expands
            this.messageFullData[this.selectedIndexTab].childmessageList = [];
            this.messageFullData[this.selectedIndexTab].childmessagestage = [];
            this.messageFullData[this.selectedIndexTab].childmessageAttributes = [];
            this.fetchedParentIds.clear();
            this.messageFullData[this.selectedIndexTab].messageAttributes = response.entitySearches as any[];
            this.collectExportDynamicColumnKeys(response.entitySearches as any[]);

            const hubMessageData = response.hubmessagedata as any[];

            const entitySearchesMap = this.messageFullData[this.selectedIndexTab].messageAttributes.reduce((acc, search) => {
              if (!acc[search.Messageid]) {
                acc[search.Messageid] = {};
              }
              acc[search.Messageid][search.Searchkey] = search.SearchValue;
              return acc;
            }, {} as Record<string, Record<string, string>>);

            const dynamicFields = new Set<string>();
            Object.values(entitySearchesMap).forEach(fields => {
              Object.keys(fields).forEach(key => {
                dynamicFields.add(key);
              });
            });

            const aggregatedData = this.messageFullData[this.selectedIndexTab].messageAttributes
              .sort((a, b) => b.Messageid.localeCompare(a.Messageid))
              .reduce((acc, item) => {
                const { Messageid, Searchkey, SearchValue } = item;

                if (!acc[Messageid]) {
                  acc[Messageid] = {
                    Messageid,
                    Searchkeys: [],
                    SearchValues: [],
                    hubMessage: hubMessageData.find(hub => String(hub.id) === String(Messageid)) || {}
                  };
                }

                acc[Messageid].Searchkeys.push(Searchkey);
                acc[Messageid].SearchValues.push(SearchValue);

                return acc;
              }, {} as Record<string, {
                Messageid: string;
                Searchkeys: string[];
                SearchValues: string[];
                hubMessage: any;
              }>);

            const enrichedData = Object.values(aggregatedData);
            this.newmsglistexportdata = enrichedData;

          }
          if (this.pagenumber > 1) {
            this.totalmessagecount = response.messagecount;
            let newMessageList: any;
            newMessageList = response.hubmessagedata as any[];
            let newMessageStageList: any;
            newMessageStageList = response.hubmessagestage as any[];
            if (newMessageList.length != 0) {
              this.tablediv = true;
              newMessageList.forEach(data => {
                this.messageList.push(data);
                newMessageStageList.forEach(ele => {
                  if (
                    ele.stagedisplay != "" &&
                    ele.messagereferenceid === data.id &&
                    ele.stagedisplay != "A"
                  ) {
                    this.messagestageList.push(ele);
                  }
                });
              });

            }
            this.messageAttributesList = response.entitySearches as any[];
          } else {
            this.messageList = [];
            this.messagestageList = [];
            this.messageList = response.hubmessagedata as any[];
            this.totalmessagecount = response.messagecount;
            let messagesublist = response.hubmessagestage as any[];
            if (this.messageList.length != 0) {
              this.tablediv = true;
              this.messageList.forEach(data => {
                messagesublist.forEach(ele => {
                  if (
                    ele.stagedisplay != "" &&
                    ele.messagereferenceid === data.id &&
                    ele.stagedisplay != "A"
                  ) {
                    this.messagestageList.push(ele);
                  }
                });
              });
            } else {
              this.tablediv = false;
              this.toastr.warning("No results found!!", "", {
                timeOut: 4000,
                positionClass: "toast-bottom-right",
              });
            }
          }
          if (isSearchClicked) {
            this.expandedRows.clear();;
          }
          if (isSearchClicked) {
            this.paginator.firstPage();
          }
          if (this.pagenumber > 0 && this.paginator != undefined) {
            this.paginator.length = this.totalmessagecount;
          }
        }
      
      error => {
        this.ngxUiLoaderService.stop();
        this.tablediv = false;
        this.toastr.error("Something Went Wrong!", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      }
   
  }


  openstagereprocess(content, dataitem, messageidcurrent, sync, routeguid) {
    this.selectedroutedefinitionid = routeguid;
    if (
      (dataitem.stagedisplay == "T" ||
        dataitem.stagedisplay == "D" ||
        dataitem.stagedisplay == "V") &&
      (sync == "false" || sync == "0")
    ) {
      this.reprocessbtn = true;
    } else {
      this.reprocessbtn = false;
    }

    this.stageid = dataitem.id;
    this.displaystage = dataitem.stagename;
    this.displaymessageid = messageidcurrent;

    this.ngxUiLoaderService.start();

    var apiname =
      "api/HubMessage/GetHubMessageLog?messagelogid=" +
      dataitem.id +
      "&archiveflag=" +
      this.archivedbcheck;
    this.service.getapiurl(apiname).subscribe({
      next: async data => {
        this.messagetypefiledownload = data["messagetype"];
        this.fileidarray = [];
        this.isContainsMultiplefileid = false;
        this.messageuniqueid = data["id"];
        try {
          this.InputData = JSON.parse(data["stageinput"]);
        } catch (e) {
          this.InputData = null;
        }

        try {
          this.OutputData = JSON.parse(data["outputdata"]);
        } catch (e) {
          let xmlDocument;
          try {
            xmlDocument = new DOMParser().parseFromString(
              data["outputdata"],
              "text/xml"
            );
            this.OutputData = beautify(data["outputdata"]);
          } catch {
            this.OutputData = data["outputdata"];
          }
        }

        this.filecontents = null;
        if (this.OutputData !== null) {
          if (dataitem.stagedisplay == "ACK") {
            this.fileOutputcheck = false;
          }

          if (Array.isArray(this.OutputData)) {
            if (this.OutputData.length > 0) {
              if (dataitem.stagedisplay == "ACK") {
                this.fileOutputcheck = false;
              }
              this.isContainsMultiplefileid = true;
              this.fileidarray = this.OutputData;
            }
          } else if (this.OutputData["fileid"] != null) {
            this.fileOutputcheck = true;
            this.fileidOutputValue = this.OutputData["fileid"];
          } else {
            this.fileOutputcheck = false;
          }
        }

        if (this.InputData != null) {
          this.transId = this.InputData["transactionid"];
          this.hash = this.InputData["hash"];
          this.senderid = this.InputData["senderagentid"];

          this.fileidInputValue = this.InputData["fileid"];
          if (this.fileidInputValue != null) {
            this.fileInputcheck = true;
          } else {
            this.fileInputcheck = false;
          }
        } else {
          this.fileInputcheck = false;
        }

        if (this.InputData == null && this.OutputData == null) {
          this.ngxUiLoaderService.stop();
          this.toastr.warning(
            "There is no input and response for " +
            dataitem.stagename +
            " stage ",
            "",
            {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            }
          );
        } else {
          if (dataitem.stagedisplay == "H" && Number(data["releaseflag"]) < 1) {
            this.releasebtn = true;
            this.dataview = true;
          } else if (dataitem.stagedisplay == "H") {
            this.dataview = true;
            this.releasebtn = false;
          } else {
            this.releasebtn = false;
            this.dataview = false;
          }
          if (
            (this.fileInputcheck &&
              this.fileOutputcheck &&
              dataitem.stagedisplay == "H") ||
            this.fileidarray.length > 1
          ) {
            this.fileidslist = [];
            // this.fileidInputValue="MjAyMS8xMC82L3NhbXBsZXBkZjEucGRmXzFmZjEyYjU0LTdlNzAtNGI4MC04ODgzLTVjYWZlMDVhOTdmMA==";
            // this.fileidOutputValue="MjAyMS8xMC82L3NhbXBsZXBkZjMucGRmXzQ0ODZmZmY4LTMyYTYtNGI0Ni1hZTJlLTgwMzNjMmE4N2Q1NQ=="
            if (this.fileidarray.length > 1) {
              this.fileidarray.forEach(element => {
                if (element.fileid) {
                  this.fileidslist.push(element.fileid);
                  this.fileOutputcheck = true;
                }
              });
              if (this.fileInputcheck) {
                this.fileidslist.push(this.fileidInputValue);
              }
            } else {
              this.fileidslist.push(this.fileidInputValue);
              this.fileidslist.push(this.fileidOutputValue);
            }

            if (this.fileidslist.length > 0) {
              let createdby = JSON.parse(
                sessionStorage.getItem("sessionObjectlogin")
              ).userdata["userid"];
              let response = await this.service.getapi(
                "api/Routes/GetFileDataMulti?fileID=" +
                this.fileidslist +
                "&contextId=" +
                this.messageuniqueid +
                "&createdBy=" +
                createdby
              );
              if (response["status"] && response["statusText"]) {
                this.ngxUiLoaderService.stop();
                this.toastr.error("Failure to download file", "", {
                  timeOut: 4000,
                  positionClass: "toast-bottom-right",
                });
              } else {
                this.ngxUiLoaderService.stop();
                var res = response as any[];
                res.forEach(element => {
                  if (element["fileformat"] == "pdf") {
                    this.ngxUiLoaderService.stop();
                    if (element["fileid"] == this.fileidInputValue) {
                      this.inputfilecontent = this._base64ToArrayBuffer(
                        element["filecontent"]
                      );
                      this.inputmediatypedisplay = false;
                    } else {
                      this.outputfilecontent = this._base64ToArrayBuffer(
                        element["filecontent"]
                      );
                      this.outputmediatypedisplay = false;
                    }
                  } else {
                    var myblob = new Blob([element["filecontent"]], {
                      type: "text/plain",
                    });
                    const outurl = URL.createObjectURL(myblob);
                    fetch(outurl)
                      .then(res => res.text())
                      .then(async datatext => {
                        this.ngxUiLoaderService.stop();
                        if (element["fileid"] == this.fileidInputValue) {
                          this.inputfilecontent = datatext;
                          this.inputmediatypedisplay = true;
                        } else {
                          this.outputfilecontent = datatext;
                          this.outputmediatypedisplay = true;
                        }
                      });
                  }
                });
                const stageModalRef = this.modalService
                  .open(content, {
                    windowClass: "myCustomModalClass",
                    backdrop: "static",
                    keyboard: false,
                  });
                this.adjustModalHeight("myCustomModalClass");
                stageModalRef.result.then(result => { });
              }
            } else {
              this.ngxUiLoaderService.stop();
              const stageModalRef2 = this.modalService
                .open(content, {
                  windowClass: "myCustomModalClass",
                  backdrop: "static",
                  keyboard: false,
                });
              this.adjustModalHeight("myCustomModalClass");
              stageModalRef2.result.then(result => { });
            }
          } else {
            this.ngxUiLoaderService.stop();
            const stageModalRef3 = this.modalService
              .open(content, {
                windowClass: "myCustomModalClass",
                backdrop: "static",
                keyboard: false,
              });
            this.adjustModalHeight("myCustomModalClass");
            stageModalRef3.result.then(result => { });
          }
        }
      },

      error: error => {
        this.ngxUiLoaderService.stop();
      },
    });
  }

  closemessageiotpopup(c) {
    this.editorOptions1.readOnly = true;
    this.messageiotreprocess = false;
    this.backupinputdata = "";
    c("close modal");
  }
  closestagepopup(c) {
    c("close modal");
  }



  autoclosetemplate() {
    setTimeout(() => {
      this.modalService.dismissAll();
    }, 3000);
  }

  copyToClip(event: any, message: string) {
    this.copyTextToClipboard(event, message, "Copied Successfully");
  }

  /** Copies text without decoding XML/HTML entities. */
  private copyTextToClipboard(
    value: unknown,
    label: string,
    successSuffix = "Copied"
  ): void {
    let text = "";
    if (typeof value === "string") {
      text = value;
    } else if (value !== null && typeof value === "object") {
      try {
        text = JSON.stringify(value, null, 2);
      } catch {
        text = "";
      }
    } else if (value !== null && value !== undefined) {
      text = String(value);
    }
    if (!text) {
      return;
    }
    const showSuccess = () => {
      this.toastr.success(`${label} ${successSuffix}`, "", {
        timeOut: 500,
        positionClass: "toast-bottom-right",
      });
    };
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).then(showSuccess).catch(() => {
        copyToClipboard(text);
        showSuccess();
      });
      return;
    }
    copyToClipboard(text);
    showSuccess();
  }

  GetMessageTypes() {
    var apiname = "api/Lookup/GetMessageType?lookuptype=messagetype";
    this.service.getapiurl(apiname).subscribe({
      next: data => {
        this.messageTypeList = data as any[];
      },
    });
  }

  reset() {
    // Force-close any open modals before resetting filters/state.
    this.closeAllOpenModals();
    this.totalmessagecount=0;
    this.searchSourceNameCleared(event);
    this.searchTargetNameCleared(event);
    this.msgfieldctrl.setValue("");
    this.msgfieldlist = [];
    this.messageFullData = [];
    this.pagenumber = 1;
    if(this.paginator!=undefined){
      this.paginator.pageIndex = 0;
    }
    this.reactiveFormroute.reset();
    this.reactiveFormsource.reset();
    this.reactiveFormroute.reset();
    this.reactiveFormtarget.reset();
    this.reactiveFormprocess.reset();
    this.selectedrouteId = "";
    this.selectedrouteDisplayName = "";
    this.selectedmessagetype = "";
    this.reactiveFormmsgtype.reset();
    this.selectedsourceaccountid = "";
    this.stageid = "";
    this.selectedsourceaccountName = "";
    this.selectedtargetaccountid = "";
    this.selectedtargetaccountName = "";
    this.selectedprocessagentid = "";
    this.selectedprocessdisplayname = "";
    this.reactiveFormmessageid.reset();
    this.selection.clear();
    this.messageList = [];
    this.messagestageList = [];
    this.childmessageList = [];
    this.fetchedParentIds.clear();
    this.tablediv = false;
    this.reactiveForentityfield.reset();
    this.reactiveFortransactionid.reset();
    this.filtermsgtaggel = true;
    this.selectedmessagestatustype = "ALL";
    this.archivedbcheck = false;
    this.pinnedcheck = false;
    this.ProcessorList = this.ProcessorAllList;
    this.reactiveFormprocess.setValue({ namep: "" });
    this.messageTypeList = this.messageTypeAllList;
    this.reactiveFormmsgtype.setValue({ msgname: "" });
    this.reactiveFormmsgstatus.reset();
    this.messageStatusList = this.messageStatusAllList;
    this.reactiveFormmsgstatus.setValue({ msgstatusname: "" });
    this.fromdate = this.datePipe.transform(
      this.getSeventhDay(new Date()),
      "yyyy-MM-dd"
    );
    this.todate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.reactiveFormprocess.patchValue(this.ProcessorList);
    this.reactiveFormmsgtype.patchValue(this.messageTypeList);
    this.reactiveFormmsgstatus.patchValue(this.messageStatusList);
    this.transactionidvalue = "";
    this.isFormView = false;
    this.reactiveFormentity.reset();
    this.isSearched = false;
    this.showSourceTarget = true;
    this.service.messagesData = "";
    this.isEngine = "HUB";
    this.EntityNameList = [];
    this.selectedEntityguid = "";
    this.selectedEntityName = "";
    this.reactiveFormparentmessageid.reset();
    this.pagenumber = 1;
    this.isadvancefilter = false;
    this.messagetypefiledownload = "";
    this.selectedsourcetypeName = "";
    this.selectedsourcedeploymentkey = "";
    this.selectedtargettypeName = "";
    this.selectedtargetdeploymentkey = "";
    this.selectedEntityType = "";
    this.selectedEntityDeploymentkey = "";
    this.selectedtargetassociatedaccountids = "";
    this.expandedRows.clear();
  }

  private closeAllOpenModals(): void {
    // Close tracked modal refs opened by this component.
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Ignore if already closed/dismissed.
          }
        }
      });
    }

    // Also dismiss any remaining ng-bootstrap modals.
    try {
      this.modalService.dismissAll();
    } catch (e) {
      // Ignore dismiss errors when no modal is active.
    }

    this.currentModalRefs = [];
    this.modalRefsTracked = [];
    this.modalWasOpen = false;
    document.body.classList.remove('modal-open');
  }


  getRouteDetails() {
    if (this.selectedrouteId != "") {
      var url = "api/Routes/GetRouteList?id=" + this.selectedrouteId;
      this.ngxUiLoaderService.start();
      this.service.getapiurl(url).subscribe({
        next: data => {
          this.ngxUiLoaderService.stop();
          if (this.selectedrouteId != "") {
            this.selectedrouteDisplayName = data["displayname"];
            this.reactiveFormroute.patchValue({
              routename: this.selectedrouteDisplayName,
            });
          }

          if (data["SENAME"] != "") {
            this.selectedsourceaccountid = data["SEGUID"];
            this.selectedsourceaccountName = data["SENAME"];

            this.reactiveFormsource.patchValue({
              name: this.selectedsourceaccountName,
            });
          }

          if (data["DENAME"] != "") {
            this.selectedtargetaccountid = data["DEGUID"];
            this.selectedtargetaccountName = data["DENAME"];
            this.reactiveFormtarget.patchValue({
              namet: this.selectedtargetaccountName,
            });
          }

          if (data["PANAME"] != "") {
            this.selectedprocessagentid = data["PAID"];
            this.selectedprocessdisplayname = data["PANAME"];
            this.reactiveFormprocess.patchValue({
              namep:
                this.selectedprocessdisplayname +
                "  " +
                "(" +
                this.selectedprocessagentid +
                ")",
            });
          }
          this.selectedmessagetype = data["messagetype"];
        },
        error: error => {
          this.ngxUiLoaderService.stop();
          this.service.copyableToastError("Unable to fetch Pipeline details with ID:" + this.selectedrouteId);
        },
      });
    }
  }
  fileOutputcheck: boolean = false;

  downloadfile(fileId, iscontainsmultiplefileid) {
    if (iscontainsmultiplefileid && this.fileidarray.length > 0) {
      for (var i = 0; i < this.fileidarray.length; i++) {
        this.downloadcontents(
          this.fileidarray[i].fileid,
          this.fileidarray[i].filename,
          "download",
          "",
          ""
        );
      }
    } else {
      this.downloadcontents(fileId, "", "download", "", "");
    }
  }
  downloadcontent(fileid, filenameatstage) {
    var apiname =
      "api/Routes/GetFileData?fileID=" +
      fileid +
      "&contextId=" +
      this.messageuniqueid +
      "&createdby=" +
      JSON.parse(sessionStorage.getItem("sessionObjectlogin")).userdata[
      "userid"
      ];

    this.service.getapiurlcontent(apiname).subscribe({
      next: data123 => {
        this.ngxUiLoaderService.stop();
        if (data123["statusmessage"] != "") {
          var fileDetails = JSON.parse(data123["statusmessage"]);
          let filename = "";

          if (filenameatstage !== "") {
            filename = filenameatstage;
          } else if (fileDetails.hasOwnProperty("filename")) {
            filename = fileDetails.filename;
          }

          if (filename == "") {
            filename = atob(fileid);
          }

          if (
            typeof fileDetails == "object" &&
            fileDetails.hasOwnProperty("contenttype")
          ) {
            let contentType = fileDetails.contenttype;

            switch (contentType) {
              case "application/xml":
                filename += ".xml";
                break;
              case "application/json":
                filename += ".js";
                break;
              case "application/pdf;base64":
                filename;
                break;
              default:
                filename += ".txt";
                break;
            }
          }
          if (filename != "" && filename.indexOf(".") == -1) {
            filename += ".txt";
          }
          var xmlDocument;
          try {
            xmlDocument = new DOMParser().parseFromString(
              data123.responsebody,
              "text/xml"
            );
          } catch {
            xmlDocument = "";
          }
          if (xmlDocument) {
            data123.responsebody = beautify(data123.responsebody);
          }
          const file = new window.Blob([data123.responsebody], {
            type: "application/octet-stream",
          });
          const downloadAncher = document.createElement("a");
          const fileURL = URL.createObjectURL(file);
          downloadAncher.href = fileURL;
          downloadAncher.download = filename;
          downloadAncher.click();
        }
      },
      error: error => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Failure to download file", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      },
    });
  }


  GetTraceData(mymodalstagelogs, messageid) {
    this.displaymessageid = messageid;
    this.ngxUiLoaderService.start();
    var url =
      "api/HubMessage/GetTraceData?messageid=" +
      messageid;
    this.service.getapiurl(url).subscribe({
      next: data => {
        if (data.length > 0) {
          this.MessageTraceData = data as any;
          if (mymodalstagelogs != "") {
            const traceModalRef = this.modalService
              .open(mymodalstagelogs, {
                windowClass: "TraceLogsModalClass",
                backdrop: "static",
                keyboard: false,
              });
            this.trackModalRef(traceModalRef, "TraceLogsModalClass");
            this.adjustModalHeight("TraceLogsModalClass");
            traceModalRef.result.then(
              (result) => { this.untrackModalRef(traceModalRef); },
              (reason) => { this.untrackModalRef(traceModalRef); }
            );
          } else {
            this.downloadFile(
              this.MessageTraceData,
              this.MessageTraceData[0]["traceid"]
            );
          }
        } else {
          this.toastr.warning(
            "There is no logs in this Message ID :" +
            " " +
            this.displaymessageid,
            "",
            {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            }
          );
        }
        this.ngxUiLoaderService.stop();
      },
      error: error => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Failure to download logs", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      },
    });
  }

  ConvertToCSV(objArray, headerList) {
    let items = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let separator = ",";
    const columns = Object.keys(items[0]).join(separator);
    const body = items
      .map(item => Object.values(item).join(separator))
      .join("\n");

    return columns + "\n" + body;
  }
  copyToClips(event: any, message: string) {
    this.copyTextToClipboard(event, message, "Copied");
  }

  downloadFile(data, filename = "data") {
    let csvData = this.ConvertToCSV(data, [
      "agentid",
      "messageid",
      "method",
      "routedefinitionid",
      "messagetype",
      "senderagentid",
      "sourceentityid",
      "destinationentityid",
      "destinationagentid",
      "response",
      "createddate",
      "fileid",
      "invokedurl",
      "stage",
      "hash",
      "response",
      "processingparam",
      "status",
      "processingtime",
    ]);

    let blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);

    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  download() {
    this.ngxUiLoaderService.start();
    this.downloadFile(
      this.MessageTraceData,
      this.MessageTraceData[0]["traceid"]
    );
    this.ngxUiLoaderService.stop();
  }


  // messagesResolve(value) {
  //   if (value.selected.length > 0) {
  //     this.checkeddata = value.selected;
  //     var dataResolve = {
  //       "id": this.checkeddata.map(function (a) { return a.id; }).join(','),
  //       "modifiedby": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
  //     }
  //     ////console.log(dataResolve);
  //     this.ngxUiLoaderService.start();
  //     this.service.hubmessageResolve(dataResolve.id, dataResolve.modifiedby).subscribe(response => {

  //       if (response['status'] && response['statusText']) {
  //         this.ngxUiLoaderService.stop();
  //         this.toastr.error('Resolve failed', "", {
  //           timeOut: 4000,
  //           positionClass: 'toast-bottom-right'
  //         });
  //       }
  //       else {
  //         this.ngxUiLoaderService.stop();
  //         if (response['status'] == "failure") {
  //           this.toastr.error(response['statusmessage'], "", {
  //             timeOut: 4000,
  //             positionClass: 'toast-bottom-right'
  //           });
  //         }
  //         else {
  //           this.toastr.success('Resolved successfully', "", {
  //             timeOut: 4000,
  //             positionClass: 'toast-bottom-right'
  //           });
  //           if (this.case360 !== undefined && this.case360.hubmessagedata !== undefined && this.case360.hubmessagedata.length > 0) {
  //             this.case360search.emit('')
  //           } else {
  //             this.SearchMessages(false);
  //           }
  //           // this.SearchMessages();
  //           // this.autoclosetemplate();
  //           //this.resetReprocess(indenty)
  //         }
  //       }
  //     }, error => {
  //       this.ngxUiLoaderService.stop();
  //       this.toastr.error('Something Went Wrong!', "", {
  //         timeOut: 4000,
  //         positionClass: 'toast-bottom-right'
  //       });
  //     });
  //   }
  // }

  // reprocessSelected(value, indenty) {

  //   if (value.selected.length > 0) {
  //     this.checkeddata = value.selected;
  //     this.messagereprocessdata = [];

  //     this.checkeddata.forEach(element => {
  //       var dataCons = {
  //         "id": element.id,
  //         "transactionid": element.transactionid,
  //         "sourceagentapikey": element.sourceagentapikey,
  //         "sourceagentid": element.sourceagentid,
  //         "sourceentityid": element.sourceentityid,
  //         "destinationentityid": element.destinationentityid,
  //         "messagetype": element.messagetype,
  //         "mode": element.mode,
  //         "messageid": element.messageid,
  //         "parentmessageid": element.parentmessageid,
  //         "format": element.format,
  //         "fileid": element.messagepayloadreference,
  //         "routedefinitionid": element.routedefinitionid,
  //         "verifyroute": "true",
  //         "modifiedby": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
  //         "parentfileid": element.parentfileid,
  //         "parentfilename": element.parentfilename
  //       }
  //       this.messagereprocessdata.push(dataCons);
  //     });

  //     this.ngxUiLoaderService.start();
  //     var apiname = "api/HubMessage/BatchMessageReprocess"
  //     this.service.searchpostapi(apiname, this.messagereprocessdata).then(response => {

  //       if (response['status'] && response['statusText']) {
  //         this.ngxUiLoaderService.stop();
  //         this.toastr.error('Reprocess failed', "", {
  //           timeOut: 4000,
  //           positionClass: 'toast-bottom-right'
  //         });
  //       }
  //       else {
  //         this.ngxUiLoaderService.stop();
  //         if (response['status'] == "failure") {
  //           this.toastr.error(response['statusmessage'], "", {
  //             timeOut: 4000,
  //             positionClass: 'toast-bottom-right'
  //           });
  //         }
  //         else {
  //           if (this.case360 !== undefined && this.case360.hubmessagedata !== undefined && this.case360.hubmessagedata.length > 0) {
  //             this.case360search.emit('')
  //           } else {
  //             this.SearchMessages(false);
  //           }

  //           this.toastr.success('Reprocessed successfully', "", {
  //             timeOut: 4000,
  //             positionClass: 'toast-bottom-right'
  //           });
  //           // this.autoclosetemplate();
  //           this.resetReprocess(indenty)
  //         }
  //       }
  //     }, error => {
  //       this.ngxUiLoaderService.stop();
  //       this.toastr.error('Something Went Wrong!', "", {
  //         timeOut: 4000,
  //         positionClass: 'toast-bottom-right'
  //       });
  //     });
  //     // this.selection.clear();
  //     // this.SearchMessages();
  //   }
  // }

  messagesResolve(value, noteResolvedtemplate) {
    this.messageSelector = value;
    const resolveModalRef = this.modalService.open(noteResolvedtemplate, {
      windowClass: "modalConfig",
      backdrop: "static",
      keyboard: false,
    });
    this.trackModalRef(resolveModalRef, "modalConfig");
    this.adjustModalHeight("modalConfig");

    resolveModalRef.result.then(() => {
      this.modalWasOpen = false;
      this.untrackModalRef(resolveModalRef);
    }, (reason) => {
      this.modalWasOpen = false;
      this.untrackModalRef(resolveModalRef);
    });
  }

  reprocessSelected(value, indenty, noteRprocessedtemplate) {
    this.messageSelector = value;
    this.messageindenty = indenty;
    const modalRef = this.modalService.open(noteRprocessedtemplate, {
      windowClass: "modalConfig",
      backdrop: "static",
      keyboard: false,
    });
    this.trackModalRef(modalRef, "modalConfig");
    this.adjustModalHeight("modalConfig");
    
    modalRef.result.then(() => {
      this.modalWasOpen = false;
      this.untrackModalRef(modalRef);
    }, (reason) => {
      this.modalWasOpen = false;
      this.untrackModalRef(modalRef);
    });
    
    // Add data attribute to identify the modal and backdrop
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.show') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-hubmessages-modal', 'true');
      }
      const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
      if (backdrop) {
        backdrop.setAttribute('data-hubmessages-modal', 'true');
      }
    }, 100);
    
    this.modalWasOpen = true;
  }

  mirthReprocessSelected(value, indenty) {
    if (value) {
      this.checkeddata = value.selected;
      this.messagereprocessdata = [];

      this.checkeddata.forEach(element => {
        var dataCons = {
          logId: element.LogId,
          statusmessage: "",
          // element.MessageStatus
          status: element.status,
        };
        this.messagereprocessdata.push(dataCons);
      });

      this.ngxUiLoaderService.start();
      this.service.reprocessapi(this.messagereprocessdata).subscribe(
        response => {
          if (response["status"] && response["statusText"]) {
            this.ngxUiLoaderService.stop();
            this.toastr.error("Reprocess failed", "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            });
          } else {
            this.ngxUiLoaderService.stop();
            // this.messageStatusList.forEach((elem) => {
            //   elem.selector = new SelectionModel<any>(true, []);
            // });
            // this.messageStatusList[this.selectedIndexTab].messageMirthList =  response.mirthMessagedata as any[];
            // this.messageStatusList[this.selectedIndexTab].messagestageMirthList = response.mirthMessagestage as any[];
            // this.messageStatusList[this.selectedIndexTab].totalmessagecountMirth =  response.messagecountMirth;
            // this.messageMirthList = response.mirthMessagedata as any[];
            // this.messagestageMirthList = response.mirthMessagestage as any[];
            // this.totalmessagecountMirth = response.messagecountMirth;

            if (response["status"] == "failure") {
              this.service.copyableToastError(response["statusmessage"]);
            } else {
              this.SearchMessages(false);
              this.service.showAsyncStatusUpdateToast('reprocess');
              // this.autoclosetemplate();
              this.resetReprocess(indenty);
            }
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
          this.toastr.error("Something Went Wrong!", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        }
      );
      // this.selection.clear();
      // this.SearchMessages();
    }
  }

  resetReprocess(value) {
    switch (value) {
      case "Created":
        this.createdSelection.clear();
        break;

      case "Success":
        this.successSelection.clear();
        break;

      case "Failure":
        this.failureSelection.clear();
        break;

      case "Auto-Healing":
        this.AutohealingSelection.clear();
        break;

      case "Ignored":
        this.IgnoreSelection.clear();
        break;

      case "Processing":
        this.ProcessingSelection.clear();
        break;

      case "Others":
        this.OtherSelection.clear();
        break;
    }
  }

  isAllSelected(selector, array) {
    const numSelected = selector.selected.length;
    const numRows = array.length;
    return numSelected === numRows;
  }

  masterToggle(selector, array) {
    this.isAllSelected(selector, array)
      ? selector.clear()
      : array.forEach(row => selector.select(row));
    this.selecteditemscount = selector.selected.length;
  }
  // isAllSelected() {
  //   const numSelected = this.selection.selected.length;
  //   const numRows = this.messageList.length;
  //   return numSelected === numRows;
  // }

  // masterToggle() {
  //   this.isAllSelected() ?
  //     this.selection.clear() :
  //     this.messageList.forEach(row => this.selection.select(row));
  // }

  onSelectAll(event) {
    this.isAddedForReprocess = true;
    const checked = event.checked;
    this.messageList.forEach(item => (item.selected = checked));
  }

  checkboxLabel(selector, array, row?: any) {
    if (!row) {
      let ui = `${this.isAllSelected(selector, array) ? "deselect" : "select"
        } all`;
      this.selecteditemscount = selector.selected.length;
      return ui;
    }
    let ui = `${selector.isSelected(row) ? "deselect" : "select"
      } row ${row.position + 1}`;
    this.selecteditemscount = selector.selected.length;
    return ui;
  }

  //   checkboxLabelMirth(selector, array, row?: any) {
  //     if (!row) {
  //       let ui = `${this.isAllSelected(selector, array) ? 'deselect' : 'select'} all`;
  //       this.selecteditemscount = selector.selected.length;
  //       return ui;
  //     }
  //     let ui = `${selector.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  //     this.selecteditemscount = selector.selected.length;
  //     return ui
  //   }

  // messageMirthList
  // checkboxLabel(row?: any) {
  //   if (!row) {
  //     return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
  //   }
  //   let ui = `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  //   return ui
  // }

  stagestitle(value) {
    return this.titlestage(value);
  }
  async releasemessage(messageId) {
    this.ngxUiLoaderService.start();
    let response = await this.service.getapi(
      "api/HubMessage/ReleaseHoldMessage?messageid=" + messageId
    );
    if (response["status"] && response["statusText"]) {
      this.ngxUiLoaderService.stop();
      this.toastr.error("Unable to release the Message", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
    } else {
      this.autoclosetemplate();
      this.SearchMessages(false);
      this.ngxUiLoaderService.stopAll();
      this.service.showAsyncStatusUpdateToast('release');
    }
  }


  editorInit(data, editor: any, type) {
    if (data == null || typeof data !== 'string') {
      return;
    }
    let formatType;
    if (this.IsValidXML(data)) {
      formatType = "xml";
    } else if (this.service.IsJsonString(data)) {
      formatType = "json";
    } else {
      formatType = "text/plain";
    }
    if (type === 'input') {
      if (this.inputFormatType !== formatType) {
        this.inputFormatType = formatType;
        this.editorOptions1 = { ...this.editorOptions1, language: formatType };
      }
    } else {
      if (this.outputFormatType !== formatType) {
        this.outputFormatType = formatType;
        this.editorOptions = { ...this.editorOptions, language: formatType };
      }
    }
  }

  editorOptions1 = { theme: 'vs', language: this.formatType, readOnly: true, wordWrap: 'on', scrollBeyondLastLine: false };

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, "");
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  filtermsgtaggel: boolean = true;

  editPipeline(item) {
    sessionStorage.setItem(
      "pipelineid",
      JSON.stringify(item.routedefinitionid)
    );
    let obj={
      id:item.routedefinitionid,
      name:item.routename
    }
    this.service.setPipelineName(JSON.stringify(obj));
  }
  buildtitle(Obj: any) {
    if (typeof Obj == "object" && Obj != null) {
      let name = `(${Obj.Type}):${Obj.LocationName}
      ${Obj.Address1}
      `;
      return name;
    }
  }
  formatXml(xml: any) {
    var formatted = "";
    var reg = /(>)(<)(\/*)/g;
    xml = xml.replace(reg, "$1\r\n$2$3");
    var pad = 0;
    xml.split("\r\n").map((node: any, index: number) => {
      var indent = 0;
      if (node.match(/.+<\/\w[^>]*>$/)) {
        indent = 0;
      } else if (node.match(/^<\/\w/)) {
        if (pad != 0) {
          pad -= 1;
        }
      } else if (node.match(/^<\w[^>]*[^\/]>.*$/)) {
        indent = 1;
      } else {
        indent = 0;
      }

      var padding = "";
      for (var i = 0; i < pad; i++) {
        padding += "  ";
      }

      formatted += padding + node + "\r\n";
      pad += indent;
    });
    return formatted;
  }
  editmessageiot(data) {
    this.messageiotreprocess = true;
    this.backupinputdata = data;
    this.editorOptions1 = { ...this.editorOptions1, readOnly: false };
  }
  resetmessageiot() {
    this.messageiotreprocess = false;
    this.message_iot_data["InputData"] = this.backupinputdata;
    this.editorOptions1 = { ...this.editorOptions1, readOnly: true };
  }
  reprocessmessageiot(c) {
    var dataCons = {
      id: this.msgObjforiot.id,
      transactionid: this.msgObjforiot.transactionid,
      sourceagentapikey: this.msgObjforiot.sourceagentapikey,
      sourceagentid: this.msgObjforiot.sourceagentid,
      sourceentityid: this.msgObjforiot.sourceentityid,
      destinationentityid: this.msgObjforiot.destinationentityid,
      messagetype: this.msgObjforiot.messagetype,
      mode: this.msgObjforiot.mode,
      messageid: this.msgObjforiot.messageid,
      parentmessageid: this.msgObjforiot.parentmessageid,
      format: this.msgObjforiot.format,
      fileid: this.msgObjforiot.messagepayloadreference,
      routedefinitionid: this.msgObjforiot.routedefinitionid,
      parentmessagereferenceid:this.msgObjforiot.parentmessagereferenceid,
      verifyroute: "true",
      filecontent: this.message_iot_data["InputData"],
      modifiedby: JSON.parse(sessionStorage.getItem("sessionObjectlogin"))
        .userdata["userid"],
      objectid: this.msgObjforiot.objectid,
      objecttype: this.msgObjforiot.objecttype
    };
    this.ngxUiLoaderService.start();
    var apiname = "api/HubMessage/ReprocessFileContent";
    this.service.postapi(apiname, dataCons).then(response => {
      if (response["status"] && response["statusText"]) {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Reprocess failed", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      } else {
        this.ngxUiLoaderService.stop();
        if (response["status"] == "failure") {
          this.service.copyableToastError(response["statusmessage"]);
        } else {
          this.SearchMessages(false);
          this.closemessageiotpopup(c);
          this.service.showAsyncStatusUpdateToast('reprocess');
          // this.autoclosetemplate();
        }
      }
    }),
      error => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Reprocess failed", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      };
  }

  isLoadingstage: boolean = false;
  selectedmessagetypeevent(item) {
    this.selectedmessagetype = item.displayname;
  }

  Clearemessagetype(event) {
    this.selectedmessagetype = "";
    this.messageTypeList = this.messageTypeAllList;
  }
  messageTypeAllList: any = [];
  async getMessagetypelist(event: any) {
    this.isLoadingstage = true;
    if (event !== "msgtype") {
      if (event == undefined) {
        this.messageTypeList = this.messageTypeAllList;
      } else {
        if (this.messageTypeList.length == 0) {
          this.messageTypeList = this.messageTypeAllList;
        }
        this.messageTypeList = this.messageTypeList.filter(t =>
          t.displayname.toLowerCase().includes(event.toLowerCase())
        );
      }
      if (this.messageTypeList.length == 0) {
        this.notfounddata = true;
      } else {
        this.notfounddata = false;
      }
      this.isLoadingstage = false;
    } else {
      await this.service
        .getapiurl("api/Lookup/GetMessageType?lookuptype=messagetype")
        .subscribe({
          next: async data => {
            data.forEach(element => {
              this.messageTypeAllList.push({ displayname: element });
            });
            this.messageTypeList = this.messageTypeAllList;

            this.isLoadingstage = false;
            if (data.length == 0) {
              this.notfounddata = true;
            } else {
              this.notfounddata = false;
            }
          },
          error: error => {
            this.isLoadingstage = false;
            this.notfounddata = true;
          },
        });
    }
  }

  isLoadingstatus: boolean = false;
  selectedmessagestatusevent(item) {
    this.selectedmessagestatustype = item.displayname;
  }

  Clearemessagestatus(event) {
    this.selectedmessagestatustype = "All";
  }
  messageStatusAllList: any = [];
  async getMessagestatuslist(event: any) {
    this.isLoadingstage = true;
    if (event !== "msgstatus") {
      if (event == undefined) {
        this.messageStatusList = this.messageStatusAllList;
      } else {
        this.messageStatusList = this.messageStatusAllList.filter(t =>
          t.displayname.toLowerCase().includes(event.toLowerCase())
        );
      }
      if (this.messageStatusList.length == 0) {
        this.notfounddata = true;
      } else {
        this.notfounddata = false;
      }
      this.isLoadingstage = false;
    } else {
      await this.service
        .getapiurl("api/Lookup/GetMessageType?lookuptype=messagestatus")
        .subscribe(data => {
          this.messageStatusAllList = [];
          data.forEach(element => {
            this.messageStatusAllList.push({ displayname: element });
          });
          this.messageStatusAllList.unshift({ displayname: "ALL" });
          this.messageStatusList = JSON.parse(
            JSON.stringify(this.messageStatusAllList)
          );
          this.messageStatusList.forEach(eleem => {
            eleem["messageList"] = [];
            eleem["messagestageList"] = [];
            eleem["totalmessagecount"] = 0;
          });
          this.isLoadingstage = false;
          if (
            this.case360 !== undefined &&
            this.case360.hubmessagedata !== undefined &&
            this.case360.hubmessagedata.length > 0
          ) {
            this.showallcaseinboundmessage();
          }
          if (data.length == 0) {
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
        }),
        error => {
          this.isLoadingstage = false;
          this.notfounddata = true;
        };
    }
  }

  @HostListener('document:click')
  onMessagesExportDocumentClick(): void {
    this.closeMessagesExportMenu();
  }

  closeMessagesExportMenu(): void {
    this.messagesExportMenuOpen = false;
    this.bulkDownloadSectionOpen = false;
  }

  private setMessagesExportMenuPosition(triggerEl: HTMLElement): void {
    const rect = triggerEl.getBoundingClientRect();
    this.messagesExportMenuStyle = {
      top: `${rect.bottom + 2}px`,
      left: `${rect.right}px`,
    };
  }

  toggleMessagesExportMenu(event: MouseEvent, selector: any): void {
    event.stopPropagation();
    if (this.messagesExportMenuOpen) {
      this.closeMessagesExportMenu();
      return;
    }
    this.exportMenuSelector = selector;
    this.exportBatchIndex = 0;
    this.bulkDownloadSectionOpen = false;
    // Keep bulk-download context in sync with the tab that opened Export (for checkboxes in dropdown).
    this.bulkDownloadPendingSelector = selector;
    this.bulkDownloadPendingMessageList = this.messageFullData?.[this.selectedIndexTab]?.messageList || [];
    this.messagesExportMenuOpen = true;
    this.setMessagesExportMenuPosition(event.currentTarget as HTMLElement);
  }

  onMessageExportClick(): void {
    this.closeMessagesExportMenu();
    this.exportreport(this.exportMenuSelector);
  }

  onDataExportClick(): void {
    this.closeMessagesExportMenu();
    this.Dataexportreport();
  }

  // Expands Image-2 bulk UI inside Export menu (pills + Download ZIP); does not start download.
  toggleBulkDownloadSection(event: MouseEvent): void {
    event.stopPropagation();
    this.bulkDownloadSectionOpen = !this.bulkDownloadSectionOpen;
  }

  // New: bulk file download from Export dropdown (checkboxes are in the panel; no separate modal).
  onBulkFileDownloadClick(): void {
    this.bulkDownloadPendingSelector = this.exportMenuSelector;
    this.bulkDownloadPendingMessageList = this.getExportMenuMessageList();
    const parents = this.getBulkDownloadParentRows(
      this.bulkDownloadPendingSelector,
      this.bulkDownloadPendingMessageList
    );
    if (parents.length === 0) {
      this.toastr.warning('Select at least one message (child messages cannot be downloaded).', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    if (parents.length > this.bulkDownloadMaxMessages) {
      this.toastr.warning(`You can download up to ${this.bulkDownloadMaxMessages} messages at a time.`, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    this.confirmBulkDownload();
  }

  // Message list for the active tab — used by Export dropdown bulk-download option.
  getExportMenuMessageList(): any[] {
    return this.messageFullData?.[this.selectedIndexTab]?.messageList || [];
  }

  getExportTotalCount(): number {
    const tabData = this.messageFullData?.[this.selectedIndexTab];
    return tabData?.totalmessagecount ?? this.totalmessagecount ?? 0;
  }

  getExportTotalBatches(): number {
    const total = this.getExportTotalCount();
    if (total <= 0) {
      return 0;
    }
    return Math.ceil(total / this.exportBatchSize);
  }

  getExportRangeStart(): number {
    return this.exportBatchIndex * this.exportBatchSize + 1;
  }

  getExportRangeEnd(): number {
    const total = this.getExportTotalCount();
    return Math.min((this.exportBatchIndex + 1) * this.exportBatchSize, total);
  }

  getExportRangeLabel(): string {
    const total = this.getExportTotalCount();
    if (total <= 0) {
      return '0-0';
    }
    return `${this.getExportRangeStart()}-${this.getExportRangeEnd()}`;
  }

  showExportRange(): boolean {
    const tabData = this.messageFullData?.[this.selectedIndexTab];
    return (
      this.getExportTotalCount() > 0 &&
      tabData?.messageList?.length > 0 &&
      tabData?.selector?.selected?.length === 0
    );
  }

  canExportPrevBatch(): boolean {
    return this.exportBatchIndex > 0;
  }

  canExportNextBatch(): boolean {
    return this.exportBatchIndex < this.getExportTotalBatches() - 1;
  }

  prevExportBatch(event: Event): void {
    event.stopPropagation();
    if (this.canExportPrevBatch()) {
      this.exportBatchIndex--;
    }
  }

  nextExportBatch(event: Event): void {
    event.stopPropagation();
    if (this.canExportNextBatch()) {
      this.exportBatchIndex++;
    }
  }

  // -------------------------------------------------------------------------
  // Minimal Failure Reason export — uses hubmessagestage already loaded in the UI.
  // No GetHubMessageLog API; same outputdata as the failed-stage icon on the grid.
  // -------------------------------------------------------------------------

  // Message status 12 = failed, 14 = ignored (matches grid status filters).
  private isNonSuccessForExport(row: any): boolean {
    const status = String(row?.status ?? "").trim();
    return status === "12" || status === "14";
  }

  // Resolve checkbox selection index to full message row when needed.
  private resolveExportMessageRow(element: any, messageList: any[] = []): any {
    if (element && typeof element === "object" && (element.id || element.messageid)) {
      return element;
    }
    if (typeof element === "number" && messageList?.[element]) {
      return messageList[element];
    }
    return element;
  }

  // hubmessagelog.status on stage row: 23 = failed, 24 = ignored.
  private isFailedStageLogForExport(stage: any): boolean {
    const stageStatus = String(stage?.status ?? "").trim();
    return stageStatus === "23" || stageStatus === "24";
  }

  // Parse failure text from stage outputdata (JSON Statusmessage or plain text).
  private extractReasonFromStageOutput(outputdata: any): string {
    if (outputdata === null || outputdata === undefined) {
      return "";
    }

    const outputText = String(outputdata).trim();
    if (!outputText) {
      return "";
    }

    if (this.isJsonString(outputText)) {
      try {
        const parsedOutput = JSON.parse(outputText);
        if (parsedOutput && typeof parsedOutput === "object") {
          const statusMessageKeys = [
            "Statusmessage",
            "statusMessage",
            "StatusMessage",
            "statusmessage",
          ];
          for (const key of statusMessageKeys) {
            const value = parsedOutput[key];
            if (value != null && String(value).trim()) {
              return String(value).trim();
            }
          }
          for (const [key, value] of Object.entries(parsedOutput)) {
            if (/statusmessage/i.test(key) && value != null && String(value).trim()) {
              return String(value).trim();
            }
          }
        }
      } catch {
        // Fall through to plain-text handling below.
      }
    }

    // Plain-text output (e.g. Agenturl is Null/Empty...) — same as failed-stage modal.
    if (!this.isJsonString(outputText)) {
      return outputText;
    }

    return "";
  }

  // Pick Failure Reason from in-memory hubmessagestage / messagestageList (no API).
  private getFailureReasonFromStageList(row: any, stageList: any[] = []): string {
    if (!row || !this.isNonSuccessForExport(row) || !stageList?.length || !row.id) {
      return "";
    }

    const linkedStages = stageList.filter(
      (stage) => String(stage?.messagereferenceid) === String(row.id)
    );

    for (const stage of linkedStages) {
      const isAcknowledgedFailure =
        String(stage?.stagename ?? "").trim().toLowerCase() === "acknowledged" &&
        !!this.extractReasonFromStageOutput(stage?.outputdata);

      if (!this.isFailedStageLogForExport(stage) && !isAcknowledgedFailure) {
        continue;
      }

      const reason = this.extractReasonFromStageOutput(stage?.outputdata);
      if (reason) {
        return reason;
      }
    }

    return "";
  }

 async exportreport(eventdata) {
    let csvData;
    let filename = "data.csv";
    
    const data: any[] = [];
    const uniqueSearchKeys: Set<string> = new Set();
    // Failure Reason column added only when export contains failed/ignored rows.
    let includeFailureReasonColumn = false;
    const exportStageList =
      this.messageFullData[this.selectedIndexTab]?.messagestageList || [];
    const exportMessageList = this.messageFullData[this.selectedIndexTab]?.messageList || [];
    
    if (eventdata.selected.length > 0) {
       this.checkeddata = eventdata.selected;
      this.checkeddata.forEach(element => {
        const exportRow = this.resolveExportMessageRow(element, exportMessageList);
        const failureReason = this.getFailureReasonFromStageList(exportRow, exportStageList);
        includeFailureReasonColumn =
          includeFailureReasonColumn ||
          this.isNonSuccessForExport(exportRow) ||
          !!failureReason.trim();
        const rowData: any = {
          "Message ID": exportRow.messageid,
          "Transaction ID": exportRow.transactionid,
          "Routedefinition ID": exportRow.routedefinitionid,
          "Routedefinition Name": exportRow.routename,
          "Source Agent ID": exportRow.sourceagentid,
          "Source Agent Name": exportRow.sourceagentname,
          "Destination Agent ID": exportRow.destinationagentid,
          "Destination Agent Name": exportRow.destinationagentname,
          "Source Entity ID": exportRow.sourceentityid,
          "Source Entity Name": exportRow.sourceentityname,
          "Destination Entity ID": exportRow.destinationentityid,
          "Destination Entity Name": exportRow.destinationentityname,
          Deployment: exportRow.deployment,
          "Message Type": exportRow.messagetype,
          "Created Date": exportRow.createddate,
          Mode: exportRow.mode,
          "Failure Reason": failureReason
        };
        const attributes = this.getAttributesForId(exportRow.id);
        if (attributes.length > 0) {
          attributes.forEach(attr => {
            const key = attr.Searchkey;
            const value = attr.SearchValue;
            uniqueSearchKeys.add(key);
            rowData[key] = value;
          });
        }
        data.push(rowData);
      });
    }  else if (eventdata.selected.length == 0 && this.messageFullData[this.selectedIndexTab].messageList.length > 0) {
      let rowsData: any[] = [];
      let batchEntitySearches: any[] = [];
      let batchStageList: any[] = [];
      const originalPageNumber = this.pagenumber;
      const targetExportCount = this.exportBatchSize;
      try {
        this.pagenumber = this.exportBatchIndex + 1;
        const pageResult = await this.SearchMessages(false, targetExportCount);
        if (pageResult && !Array.isArray(pageResult)) {
          rowsData = (pageResult.hubmessagedata || []).slice(0, targetExportCount);
          batchEntitySearches = pageResult.entitySearches || [];
          batchStageList = pageResult.hubmessagestage || [];
          this.collectExportDynamicColumnKeys(batchEntitySearches);
        }
      } finally {
        this.pagenumber = originalPageNumber;
      }
      
      this.ngxUiLoaderService.stop();
      rowsData.forEach(element => {
        const failureReason = this.getFailureReasonFromStageList(element, batchStageList);
        includeFailureReasonColumn =
          includeFailureReasonColumn ||
          this.isNonSuccessForExport(element) ||
          !!failureReason.trim();
        const rowData: any = {
          "Message ID": element.messageid,
          "Transaction ID": element.transactionid,
          "Routedefinition ID": element.routedefinitionid,
          "Routedefinition Name": element.routename,
          "Source Agent ID": element.sourceagentid,
          "Source Agent Name": element.sourceagentname,
          "Destination Agent ID": element.destinationagentid,
          "Destination Agent Name": element.destinationagentname,
          "Source Entity ID": element.sourceentityid,
          "Source Entity Name": element.sourceentityname,
          "Destination Entity ID": element.destinationentityid,
          "Destination Entity Name": element.destinationentityname,
          Deployment: element.deployment,
          "Message Type": element.messagetype,
          "Created Date": element.createddate,
          Mode: element.mode,
          "Failure Reason": failureReason
        };
        const attributes = this.getAttributesFromEntitySearches(element.id, batchEntitySearches);
        if (attributes.length > 0) {
          attributes.forEach(attr => {
            const key = attr.Searchkey;
            const value = attr.SearchValue;
            uniqueSearchKeys.add(key);
            rowData[key] = value;
          });
        }

        data.push(rowData);
      });

      this.exportDynamicColumnKeys.forEach(key => uniqueSearchKeys.add(key));
    }
    else {
      this.newmsglistexportdata.forEach((element: any) => {
        const exportRow = element.hubMessage || element;
        const failureReason = this.getFailureReasonFromStageList(exportRow, exportStageList);
        includeFailureReasonColumn =
          includeFailureReasonColumn ||
          this.isNonSuccessForExport(exportRow) ||
          !!failureReason.trim();
        const rowData: any = {
         "Message ID": exportRow.messageid,
          "Transaction ID": exportRow.transactionid,
          "Routedefinition ID": exportRow.routedefinitionid,
          "Routedefinition Name": exportRow.routename,
          "Source Agent ID": exportRow.sourceagentid,
          "Source Agent Name": exportRow.sourceagentname,
          "Destination Agent ID": exportRow.destinationagentid,
          "Destination Agent Name": exportRow.destinationagentname,
          "Source Entity ID": exportRow.sourceentityid,
          "Source Entity Name": exportRow.sourceentityname,
          "Destination Entity ID": exportRow.destinationentityid,
          "Destination Entity Name": exportRow.destinationentityname,
          Deployment: exportRow.deployment,
          "Message Type": exportRow.messagetype,
          "Created Date": exportRow.createddate,
          Mode: exportRow.mode,
          "Failure Reason": failureReason
        };
        element.Searchkeys.forEach((key: string, index: number) => {
          uniqueSearchKeys.add(key);
          rowData[key] = element.SearchValues[index];
        });

        data.push(rowData);
      });
    }



    const csvHeaders = [
      "Message ID",
      "Transaction ID",
      "Routedefinition ID",
      "Routedefinition Name",
      "Source Agent ID",
      "Source Agent Name",
      "Destination Agent ID",
      "Destination Agent Name",
      "Source Entity ID",
      "Source Entity Name",
      "Destination Entity ID",
      "Destination Entity Name",
      "Deployment",
      "Message Type",
      "Created Date",
      "Mode",
      // Add Failure Reason only when export contains failed/ignored (non-success) rows.
      ...(includeFailureReasonColumn ? ["Failure Reason"] : []),
      ...Array.from(uniqueSearchKeys)
    ];

    if (data.length > 0) {
      csvData = this.ConvertToCSVmessagelist(data, csvHeaders);

      let blob = new Blob(["\ufeff" + csvData], {
        type: "text/csv;charset=utf-8;",
      });
      let dwldLink = document.createElement("a");
      let url = URL.createObjectURL(blob);

      dwldLink.setAttribute("href", url);
      dwldLink.setAttribute("download", filename);
      dwldLink.style.visibility = "hidden";
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
    } else {
      this.toastr.warning("There is no data !", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
    }
  }


  // ConvertToCSVmessagelist(objArray, headerscus) {
  //   let items = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  //   let separator = ",";
  //   const columns = Object.keys(items[0]).join(separator);
  //   const body = items
  //     .map(item => Object.values(item).join(separator))
  //     .join("\n");
  //   if (headerscus == "") {
  //     return columns + "\n" + body;
  //   } else {
  //     return headerscus + "\n" + body;
  //   }
  // }

  ConvertToCSVmessagelist(objArray: any[], headerscus: string[]): string {
    const headerIndexMap: { [key: string]: number } = {};
    headerscus.forEach((header, index) => {
      headerIndexMap[header] = index;
    });

    const quoteValue = (value: any): string => {
      if (value === null || value === undefined) {
        return '""';
      }
      const escapedValue = value.toString().replace(/"/g, '""');
      return `"${escapedValue}"`;
    };
    const headerRow = headerscus.map(header => quoteValue(header)).join(",");
    const bodyRows = objArray.map(item => {
      return headerscus.map(header => {
        return quoteValue(item[header]);
      }).join(",");
    }).join("\n");

    return headerRow + "\n" + bodyRows;
  }

  CheckValidationStauts(data) {
    if (
      data.status == "11" &&
      (data.messagetype.includes("bar") ||
        data.messagetype.includes("dft") ||
        data.messagetype.includes("order") ||
        data.messagetype.includes("orders") ||
        data.messagetype.includes("result") ||
        data.messagetype.includes("vcdft"))
    ) {
      return true;
    } else {
      return false;
    }
  }

  OnValidation(item) {
    this.ngxUiLoaderService.start();
    this.service
      .GetMessageDetailsByID(item.messageid)
      .pipe(
        mergeMap(data => {
          if (data.length > 0) {
            let obj = {
              CaseId: data[0].CaseGUID.toString(),
              MessageID: item.messageid,
              Deployment: data[0].Deployment,
              Direction: data[0].Direction,
              MessageType: item.messagetype,
            };
            console.log(
              "Input params to data validation api is " + JSON.stringify([obj])
            );
            return this.service.dataValidationapi([obj]);
          } else {
            // Return an observable with default or no data
            return of(null);
          }
        })
      )
      .subscribe(
        ResponseData => {
          this.ngxUiLoaderService.stop();
          if (ResponseData.length > 0) {
            const validationModalRef = this.modalService.open(DataValidationComponent, {
              windowClass: "Mode_Boot",
              backdrop: "static",
              keyboard: false,
            });
            validationModalRef.componentInstance.inputDataInModalComponent = ResponseData;
            
            this.trackModalRef(validationModalRef, "Mode_Boot");
            this.adjustModalHeight("Mode_Boot");
            
            validationModalRef.result.then(
              (result) => { 
                this.modalWasOpen = false;
                this.untrackModalRef(validationModalRef);
              },
              (reason) => {
                this.modalWasOpen = false;
                this.untrackModalRef(validationModalRef);
              }
            );
            
            // Add data attribute to identify the modal
            setTimeout(() => {
              const modalElement = document.querySelector('.modal.Mode_Boot') as HTMLElement;
              if (modalElement) {
                modalElement.setAttribute('data-hubmessages-modal', 'true');
              }
            }, 0);
            
            this.modalWasOpen = true;
          } else {
            this.ngxUiLoaderService.stop();
            this.toastr.warning("No data found", "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            });
          }
        },
        error => {
          this.toastr.warning(
            "Error occured while calling GetMessageDetailsByID api",
            "",
            {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            }
          );
          this.ngxUiLoaderService.stop();
        }
      );
  }

  IsValidXML(data) {
    if (data == null || typeof data !== 'string') {
      return false;
    }
    const trimmed = data.trim();
    return trimmed.startsWith('<') && trimmed.endsWith('>');
  }

  entityCustomFilter = function (EntityNameList: any[], query: string): any[] {
    return EntityNameList;
  };
  async getEntityNames(event: any) {
    var valuesa = event;
    let highlighted;
    if (event.includes(":")) {
      let splitValues = event.split(":");
      if (splitValues.length === 2) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        event = splitValues.join(":");
      }
      if (splitValues.length === 3) {
        splitValues[1] = splitValues[1].trimStart();
        splitValues[1] = " " + splitValues[1];
        splitValues[2] = splitValues[2].trimStart();
        splitValues[2] = " " + splitValues[2];
        event = splitValues.join(":");
      }
    }
    if (highlighted != "") {
      highlighted = event;
    }
    this.selectedEntityguid = "";
    this.reactiveFormentity.patchValue({
      entityname: event,
    });
    if (valuesa != "" && !valuesa.endsWith(":") && !valuesa.endsWith(": ")) {
      let valueToSendToApiWithOutWhiteSpace = valuesa.replaceAll(": ", ":");
      //var createSearch = "api/SearchAccounts/GetAccountNamesListAsync?lSearch=" + valueToSendToApiWithOutWhiteSpace;

      this.isLoadingentity = true;
      let obj = {
        lsearch: valueToSendToApiWithOutWhiteSpace,
      };
      //let response = await this.service.getapi(createSearch);
      this.service.GetAccountNamesListAsync(obj).subscribe((response: any) => {
        if (response["status"] && response["statusText"]) {
          this.isLoadingentity = false;
          this.EntityNameList = [];
          this.notfounddata = true;
          this.toastr.error("Unable to fetch Entity Details", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        } else {
          if (response.length > 0) {
            this.EntityNameList = response;
            this.EntityNameList = this.service.transformAlphabetically(
              this.EntityNameList,
              "LocationName"
            );
            this.EntityNameList.map(
              obj =>
              (obj.LocationName =
                obj.UniqueID !== null && obj.UniqueID !== undefined
                  ? `${obj.LocationName} ${"(" +
                  obj.LocationGUID +
                  ")"} ${"(" + obj.UniqueID + ")"}`
                  : `${obj.LocationName} ${"(" + obj.LocationGUID + ")"}`)
            );
          }
          if (response.length == 0) {
            this.EntityNameList = [];
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
          }
          this.selectedsourceaccountid = "";
          this.isLoadingentity = false;
        }
      });
    } else {
      this.EntityNameList = [];
      this.notfounddata = true;
    }
  }
  selectedEntity(item) {
    this.selectedEntityguid = item.LocationGUID;
    this.selectedEntityName = item.LocationName;
    this.selectedEntityType = item.TypeName;
    this.selectedEntityDeploymentkey = item.deploymentkey;
  }
  EntityNameListCleare() {
    this.selectedEntityguid = "";
    this.selectedEntityName = "";
    this.selectedEntityType = "";
    this.selectedEntityDeploymentkey = "";
  }
  searchEntityCleared() {
    this.isLoadingentity = false;
    this.EntityNameList = [];
    this.selectedEntityguid = "";
    this.notfounddata = false;
    this.selectedEntityType = "";
    this.selectedEntityDeploymentkey = "";
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
      this.modalRefsTracked = [];
    }
    
    this.service.messagesData = "";
    this.msgsubtab.unsubscribe();
    
    // Clean up tab change subscription
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkvalid(value) {
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (
      value !== 0 &&
      value !== "_" &&
      value !== "%" &&
      value !== "+" &&
      value !== "-" &&
      !format.test(value)
    ) {
      this.isvalidSPLchar = false;
    } else {
      this.isvalidSPLchar = true;
    }
  }

  onSearchMirth() {
    // let obj=this.MirthFitlerForm.value;
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (
      this.MirthFitlerForm.value.caseid !== "" &&
      format.test(this.MirthFitlerForm.value.caseid)
    ) {
      this.checkvalid(this.MirthFitlerForm.value.caseid);
    } else {
      this.isvalidSPLchar = false;
    }

    let newobj = {
      handler: this.MirthFitlerForm.value.handler
        ? this.MirthFitlerForm.value.handler
        : "",
      LogId: this.MirthFitlerForm.value.LogId
        ? this.MirthFitlerForm.value.LogId
        : "",
      status: this.MirthFitlerForm.value.status
        ? this.MirthFitlerForm.value.status
        : "",
      caseid:
        this.MirthFitlerForm.value.caseid !== ""
          ? this.MirthFitlerForm.value.caseid
          : 0,
      createddate: this.MirthFitlerForm.value.createddate
        ? this.MirthFitlerForm.value.createddate
        : "",
      processingdate: this.MirthFitlerForm.value.processingdate
        ? this.MirthFitlerForm.value.processingdate
        : "",
      deployment: this.messageData.deployment,
    };
    newobj.createddate = this.datePipe.transform(
      newobj.createddate,
      "yyyy-MM-dd"
    );
    newobj.processingdate = this.datePipe.transform(
      newobj.processingdate,
      "yyyy-MM-dd"
    );

    this.ngxUiLoaderService.start();
    // var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

    this.service.getMirthSearch(newobj).subscribe(
      data => {
        if (
          this.invalidlogID == true &&
          format.test(this.MirthFitlerForm.value.LogId)
        ) {
          this.toastr.error("Invaild LogID", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
          this.ngxUiLoaderService.stop();
          // this.messageFullData = [];
          setTimeout(() => {
            this.selectedIndexTab = 0;
            this.messageData.MessageDetails = [];
            this.messageFullData[this.selectedIndexTab].messageList = [];
            this.messageFullData[this.selectedIndexTab].totalmessagecount = 0;
          });
        }

        if (this.isvalidSPLchar) {
          this.toastr.error("Invalid CaseID", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
          this.ngxUiLoaderService.stop();
          // this.messageFullData = [];
          setTimeout(() => {
            this.selectedIndexTab = 0;
            this.messageData.MessageDetails = [];
            this.messageFullData[this.selectedIndexTab].messageList = [];
            this.messageFullData[this.selectedIndexTab].totalmessagecount = 0;
          });
          // this.messageData.MessageDetails=[]
          return;
        }

        if (data !== null) {
          this.ngxUiLoaderService.stop();
          // this.getsaved(data);
          // this.messageFullData =[]
          this.selectedIndexTab = 0;
          this.messageData.MessageDetails = data;

          // this.messageFullData.forEach((ele) => {
          //   ele.selector = new SelectionModel<any>(true, []);
          // });
          this.messageFullData[this.selectedIndexTab].messageList = data;
          this.messageFullData[this.selectedIndexTab].totalmessagecount =
            data.length;
          this.isEngine = this.messageData["engine"];
        }
      },
      error => {
        this.ngxUiLoaderService.stop();
      }
    );
  }

  getMirthData(column: any, event: any) {
    this.isLoadinghandler = false;
    this.isLoadinglogid = false;
    this.isLoadingcaseid = false;
    this.isLoadingstatusMirth = false;
    this.isLoadingCreatedDate = false;
    this.isLoadingProcessingDate = false;

    this.service.getMirthFilters(column, event).subscribe(
      data => {
        if (column == "handler") {
          this.isLoadinghandler = true;
          if (data.length == 0) {
            this.handlerList = [];
            this.isLoadinghandler = false;
            this.notfounddata = true;
          } else {
            this.notfounddata = false;
            this.isLoadinghandler = false;
            this.handlerList = [];
            this.handlerList = data;
          }
        } else if (column == "LogId") {
          this.isLoadinglogid = true;
          if (data.length == 0 && data.length == "") {
            this.logIdList = [];
            this.isLoadinglogid = false;
            this.notfounddata1 = true;
            this.invalidlogID = true;
            // this.invalidcaseid=false;
          } else {
            this.invalidlogID = false;
            // this.invalidcaseid=false;
            this.notfounddata1 = false;
            this.isLoadinglogid = false;
            this.logIdList = [];
            this.logIdList = data;
          }
        } else if (column == "caseid") {
          this.isLoadingcaseid = true;
          if (data.length == 0 && data.length == "") {
            this.caseIdList = [];
            this.isLoadingcaseid = false;
            this.notfounddata2 = true;
            this.invalidcaseid = true;
            // this.invalidlogID=false;
          } else {
            // this.invalidlogID=false;
            this.invalidcaseid = false;
            this.notfounddata2 = false;
            this.isLoadingcaseid = false;
            this.caseIdList = [];
            this.caseIdList = data;
          }
        } else if (column == "status") {
          this.isLoadingstatusMirth = true;
          if (data.length == 0) {
            this.statusMirth = [];
            this.isLoadingstatusMirth = false;
            this.notfounddata3 = true;
          } else {
            this.notfounddata3 = false;
            this.isLoadingstatusMirth = false;
            this.statusMirth = [];
            this.statusMirth = data;
          }
        } else if (column == "createddate") {
          this.isLoadingCreatedDate = true;
          if (data.length == 0) {
            this.createdDate = [];
            this.isLoadingCreatedDate = false;
            this.notfounddata4 = true;
          } else {
            this.notfounddata4 = false;
            this.isLoadingCreatedDate = false;
            this.createdDate = [];
            this.createdDate = data;
          }
        } else if (column == "processingdate") {
          this.isLoadingProcessingDate = true;
          if (data.length == 0) {
            this.processingDate = [];
            this.isLoadingProcessingDate = false;
            this.notfounddata5 = true;
          } else {
            this.notfounddata5 = false;
            this.isLoadingProcessingDate = false;
            this.processingDate = [];
            this.processingDate = data;
          }
        }
      },
      error => {
        this.isLoadinghandler = false;
        this.notfounddata = true;
        this.notfounddata1 = true;
        this.notfounddata2 = true;
        this.notfounddata3 = true;
        this.notfounddata4 = true;
        this.notfounddata5 = true;
        switch (column) {
          case "caseid":
            this.invalidcaseid = true;
            break;
          case "LogId":
            this.invalidlogID = true;
            break;

          default:
            break;
        }
      }
    );
  }
  getPreviousDay(date = new Date()) {
    const previous = new Date(date.getTime());
    previous.setDate(date.getDate() - 1);

    return previous;
  }
  searchHandlerCleared(event) {
    this.isLoadinghandler = false;
    this.handlerList = [];
    this.notfounddata = false;
  }
  searchLogIdCleared(event) {
    this.isLoadinghandler = false;
    this.logIdList = [];
    this.notfounddata1 = false;
    this.invalidlogID = false;
  }
  searchCaseIdCleared(event) {
    this.isLoadinghandler = false;
    this.caseIdList = [];
    this.notfounddata2 = false;
    this.invalidcaseid = false;
  }
  searchStatusMirthCleared(event) {
    this.isLoadinghandler = false;
    this.statusMirth = [];
    this.notfounddata3 = false;
  }
  searchCreatedDateCleared(event) {
    this.isLoadinghandler = false;
    this.createdDate = [];
    this.notfounddata4 = false;
  }
  searchProcessingDateCleared(event) {
    this.isLoadinghandler = false;
    this.processingDate = [];
    this.notfounddata5 = false;
  }
  removemsgfieldvalue(tolist: any): void {
    const index = this.msgfieldlist.indexOf(tolist);

    if (index >= 0) {
      this.msgfieldlist.splice(index, 1);
    }
    this.msgfieldInput.nativeElement.focus();
  }
  addmsgvalue(event: MatChipInputEvent): void {
    if (event.value !== "") {
      const input = event.input;
      const value = event.value;
      let valuelist = [];
      if ((value || "").trim()) {
        if (value.includes("|")) {
          valuelist = value.split("|");
          if (valuelist.length <= 100) {
            valuelist.forEach(X => {
              if (X != "") {
                this.msgfieldlist.push({ msgvalue: X.trim() });
              }
            });
          } else {
            this.toastr.warning("Message Field accepts max 100 values", "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            });
            return;
          }
          this.msgfieldctrl.setValue("");
          this.msgfieldInput.nativeElement.value = "";
        } else {
          this.msgfieldlist.push({ msgvalue: value.trim() });
          this.msgfieldctrl.setValue("");
          this.msgfieldInput.nativeElement.value = "";
        }
      }
      this.msgfieldInput.nativeElement.focus();
    } else {
      this.isfocus = false;
    }
  }
  // onScroll($event) {
  //   let count = 0;
  //   let isvalid = true;
  //   count = (parseInt(this.totalmessagecount.toString()) / 100);
  //   let exactvalue = Math.floor(count);
  //   let result = (count - exactvalue) !== 0;
  //   if (result && ((exactvalue + 1) == this.pagenumber)) {
  //     isvalid = false;
  //   }
  //   else if (this.pagenumber == count) {
  //     isvalid = false;
  //   }
  //   if (isvalid) {
  //     this.ngxUiLoaderService.start();
  //     this.pagenumber += 1;
  //     this.SearchMessages(false);
  //   }

  // }
  event: any;
  getPageDetails(event: { pageIndex: number; pageSize: number }) {
    if (event.pageIndex == 0) {
      this.pagenumber = 1;
    } else {
      this.pagenumber = event.pageIndex + 1;
    }

    this.PageSize = 100;
    this.SearchMessages(false);
  }
  focusmatchipinput() {
    this.msgfieldInput.nativeElement.focus();
  }
  getSeventhDay(date = new Date()) {
    const seventhday = new Date(date.getTime());
    seventhday.setDate(date.getDate() - 6);
    return seventhday;
  }

  async clearnotepopupvalues() {
    this.messageNote = "";
  }
  async closenote(h) {
    await this.clearnotepopupvalues();
    h("close modal");
  }

  async closeResolved(i) {
    await this.clearnotepopupvalues();
    i("close modal");
  }

  async saveNoteReprocess(h) {
    if (this.messageSelector.selected.length > 0) {
      this.checkeddata = this.messageSelector.selected;
      this.messagereprocessdata = [];
      this.checkeddata.forEach(element => {
        var dataCons = {
          id: element.id,
          transactionid: element.transactionid,
          sourceagentapikey: element.sourceagentapikey,
          sourceagentid: element.sourceagentid,
          sourceentityid: element.sourceentityid,
          destinationentityid: element.destinationentityid,
          messagetype: element.messagetype,
          mode: element.mode,
          messageid: element.messageid,
          parentmessageid: element.parentmessageid,
          parentmessagereferenceid:element.parentmessagereferenceid,
          format: element.format,
          fileid: element.messagepayloadreference,
          routedefinitionid: element.routedefinitionid,
          verifyroute: "true",
          modifiedby: JSON.parse(sessionStorage.getItem("sessionObjectlogin")).userdata["userid"],
          note: this.messageNote,
          action: "Reprocessed",
          fromDate: this.fromdate + " 00:00:00",
          toDate: this.todate + " 23:59:59",
          filename: element.filename,
          archivedbcheck:this.archivedbcheck,
          objectid: element.objectid,
          objecttype: element.objecttype
        };
        this.messagereprocessdata.push(dataCons);
      });
      this.ngxUiLoaderService.start();
      var apiname = "api/HubMessage/BatchMessageReprocess";
      this.service.searchpostapi(apiname, this.messagereprocessdata).then(
        response => {
          if (response["status"] && response["statusText"]) {
            this.ngxUiLoaderService.stop();
            this.toastr.error("Reprocess failed", "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            });
          } else {
            this.clearnotepopupvalues();
            this.ngxUiLoaderService.stop();
            if (response["status"] == "failure") {
              this.service.copyableToastError(response["statusmessage"]);
            } else {
              if (
                this.case360 !== undefined &&
                this.case360.hubmessagedata !== undefined &&
                this.case360.hubmessagedata.length > 0
              ) {
                this.case360search.emit("");
              } else {
                this.SearchMessages(false);
              }

              this.closenote(h);
              this.service.showAsyncStatusUpdateToast('reprocess');
              // this.autoclosetemplate();
              this.resetReprocess(this.messageindenty);
            }
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
          this.toastr.error("Something Went Wrong!", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        }
      );
      // this.selection.clear();
      // this.SearchMessages();
    }
  }

  async saveNoteResolved(i) {
    if (this.messageSelector.selected.length > 0) {
      this.checkeddata = this.messageSelector.selected;
      this.messagereprocessdata = [];
      this.checkeddata.forEach(element => {
        var dataCons = {
          id: element.id,
          modifiedby: JSON.parse(sessionStorage.getItem("sessionObjectlogin"))
            .userdata["userid"],
          sourceagentid: element.sourceagentid,
          transactionid: element.transactionid,
          routeid: element.routedefinitionid,
          messageid: element.messageid,
          note: this.messageNote,
          action: "Resolved",
          stageid: "-1",
        };
        this.messagereprocessdata.push(dataCons);
      });
      var apiname = "api/HubMessage/HubMessageStatusUpdate";
      this.ngxUiLoaderService.start();
      this.service.searchpostapi(apiname, this.messagereprocessdata).then(
        response => {
          if (response["status"] && response["statusText"]) {
            this.ngxUiLoaderService.stop();
            this.toastr.error("Resolve failed", "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            });
          } else {
            this.ngxUiLoaderService.stop();
            if (response["status"] == "failure") {
              this.service.copyableToastError(response["statusmessage"]);
            } else {
              this.closeResolved(i);
              this.toastr.success("Resolved successfully", "", {
                timeOut: 500,
                positionClass: "toast-bottom-right",
              });
              if (
                this.case360 !== undefined &&
                this.case360.hubmessagedata !== undefined &&
                this.case360.hubmessagedata.length > 0
              ) {
                this.case360search.emit("");
              } else {
                this.SearchMessages(false);
              }
              // this.SearchMessages();
              // this.autoclosetemplate();
              //this.resetReprocess(indenty)
            }
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
          this.toastr.error("Something Went Wrong!", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        }
      );
    }
  }

  //view the downloand file
  viewFile(response) {
    let namemodal = {
      name: response.filename,
      fullfile: response.filecontent,
      type: response.fileformat,
    };
    const modalRef = this.modalService.open(FileViewExplorerComponent, {
      windowClass: "myCustomModalViewfile",
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.fileData = namemodal;
    modalRef.componentInstance.fileType = response.fileformat;
    this.adjustModalHeight("myCustomModalViewfile");
    modalRef.result.then(() => { });
  }

  closepopupdata(u) {
    u("close modal");
  }

  // CompareMessages(messageData) {
  //   this.showDropdown = true;
  // }
  GetThestagemessage(stagevlaue, eventdata) {
    const firstAttrs = this.getAttributesForId(eventdata._selected[0].id);
    const secondAttrs = this.getAttributesForId(eventdata._selected[1].id);
    
    let data = {
      stagevlaue: stagevlaue,
      messagedata: eventdata._selected,
      firstentitysearchdata: firstAttrs,
      secondentitysearchdata: secondAttrs,
      archivedbcheck : this.archivedbcheck
    };

    const modalRef = this.modalService.open(CompareComponent, {
      windowClass: "myCustomModalClass",
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.messagedata = data;
    modalRef.componentInstance.archivedbcheck = this.archivedbcheck;
    this.trackModalRef(modalRef, "myCustomModalClass");
    this.adjustModalHeight("myCustomModalClass");
    
    modalRef.result.then(() => {
      this.modalWasOpen = false;
      this.untrackModalRef(modalRef);
    }, (reason) => {
      this.modalWasOpen = false;
      this.untrackModalRef(modalRef);
    });
    
    // Add data attribute to identify the modal and backdrop
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.show') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-hubmessages-modal', 'true');
      }
      const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
      if (backdrop) {
        backdrop.setAttribute('data-hubmessages-modal', 'true');
      }
    }, 100);
    
    this.modalWasOpen = true;
  }

  // Open compare with pinned message modal
  openCompareWithPinnedMessage(messageData: any,eventdata): void {
    if (!messageData) {
      this.toastr.warning('Please select a message first', '', {
        timeOut: 3000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    // Create a copy of selected items to avoid reactive changes affecting selection count
    const selectedItems = [...eventdata._selected];
    
    const firstAttrs = this.getAttributesForId(selectedItems[0].id);
    //const secondAttrs = this.getAttributesForId(selectedItems[1].id);
    
    let data = {
      messagedata: selectedItems,
      firstentitysearchdata: firstAttrs,
      //secondentitysearchdata: secondAttrs
    };

    // Get route GUID from message
    const routeGuid = messageData.routeguid || messageData.handlerdata2 || messageData.routedefinitionid || messageData.caseid || '';
    if (!routeGuid) {
      this.toastr.warning('Unable to compare: Missing route information', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    const modalRef = this.modalService.open(ComparePinnedComponent, {
      windowClass: "compare-pinned-modal",
      backdrop: "static",
      keyboard: false,
      size: "xl"
    });

    modalRef.componentInstance.selectedMessage = messageData;
    modalRef.componentInstance.routeGuid = routeGuid;
    modalRef.componentInstance.routeName = messageData.routename || messageData.handlerdata2 || '';
    modalRef.componentInstance.archivedbcheck = this.archivedbcheck;
    modalRef.componentInstance.messagedata = data;
    this.adjustModalHeight("compare-pinned-modal");
    
    // Track modal reference for hide/show and ngOnDestroy
    this.trackModalRef(modalRef, "compare-pinned-modal");
    this.modalWasOpen = true;
    
    // Add data attribute to identify the modal and backdrop
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.compare-pinned-modal') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-hubmessages-modal', 'true');
      }
      const backdrop = document.querySelector('.modal-backdrop') as HTMLElement;
      if (backdrop) {
        backdrop.setAttribute('data-hubmessages-modal', 'true');
      }
    }, 100);

    // Handle modal close without affecting selection
    modalRef.result.then(() => {
      this.modalWasOpen = false;
      this.untrackModalRef(modalRef);
      // Modal closed - selection should remain unchanged
    }).catch(() => {
      this.modalWasOpen = false;
      this.untrackModalRef(modalRef);
      // Modal dismissed - selection should remain unchanged
    });
  }

  // Get route GUID from message data
  getRouteGuid(data: any): string {
    // Try different possible fields for route GUID
    return data.routeguid || data.handlerdata2 || data.routedefinitionid || data.caseid || '';
  }

  // Toggle pin/unpin message
  async togglePinMessage(data: any, event: Event): Promise<void> {
    event.stopPropagation();
    const messageId = data.messageid || data.handler;
    const routeGuid = this.getRouteGuid(data);

    if (!messageId || !routeGuid) {
      this.toastr.warning('Unable to pin message: Missing message ID or route information', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      return;
    }

    // Check if message is pinned using the ispinned property from API response
    const isPinned = data.ispinned === true;

    if (isPinned) {
      const message = `Are you sure you want to unpin this message?`;
              const dialogData = new ConfirmDialogModel("Confirm Action", message, 'confirm', '');
              const dialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: "500px", data: dialogData, disableClose: true });
              const dialogResult = await dialogRef.afterClosed().toPromise();
              if (dialogResult === false) {
                return;
              }
              
      // Unpin message - call UnPinMessage API endpoint
      const sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
      const pinnedBy = sessionObject?.userdata?.['userid'] || '';
      this.ngxUiLoaderService.start();
      this.service.unpinMessage(messageId, routeGuid, pinnedBy).subscribe(
        response => {
          this.ngxUiLoaderService.stop();
          if (response && response.status === "success") {
            // UnpinMessage returns responsebody as null, so set ispinned to false directly
            data.ispinned = false;
            this.toastr.success(response.statusmessage || 'Message unpinned successfully', '', {
              timeOut: 3000,
              positionClass: 'toast-bottom-right'
            });
          } else {
            // API returned failure status
            this.toastr.error(response?.statusmessage || 'Failed to unpin message', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
          this.toastr.error('Failed to unpin message. Please try again.', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
        }
      );
    } else {
      // Pin message - open dialog to get reason and filename
      this.pinMessageReason = '';
      this.pinMessagePinName = '';
      
      const modalRef = this.modalService.open(this.pinMessageDialogTemplate, {
        windowClass: "pinMessageModalClass",
        backdrop: "static",
        keyboard: false
      });
      this.adjustModalHeight("pinMessageModalClass");
      
      // Track modal reference for hide/show and ngOnDestroy
      this.trackModalRef(modalRef, "pinMessageModalClass");
      this.modalWasOpen = true;
      
      // Add data attribute to identify the modal and backdrop
      setTimeout(() => {
        const modalElement = document.querySelector('.modal.pinMessageModalClass') as HTMLElement;
        if (modalElement) {
          modalElement.setAttribute('data-hubmessages-modal', 'true');
        }
        const backdrop = document.querySelector('.modal-backdrop') as HTMLElement;
        if (backdrop) {
          backdrop.setAttribute('data-hubmessages-modal', 'true');
        }
      }, 100);

      modalRef.result.then(
        (result) => {
          this.modalWasOpen = false;
          this.untrackModalRef(modalRef);
          if (result === 'confirm') {
            // Validate mandatory fields before proceeding
            const trimmedReason = (this.pinMessageReason || '').trim();
            const trimmedPinName = (this.pinMessagePinName || '').trim();

            if (!trimmedReason || !trimmedPinName) {
              if (!trimmedReason) {
                this.toastr.error('Reason is required', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right'
                });
              }
              if (!trimmedPinName) {
                this.toastr.error('Pin Name is required', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right'
                });
              }
              return;
            }

            // User confirmed - proceed with pinning
            const sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
            const pinnedBy = sessionObject?.userdata?.['userid'] || '';
            this.ngxUiLoaderService.start();
            this.service.pinMessage(messageId, routeGuid, pinnedBy, trimmedReason, trimmedPinName).subscribe(
              response => {
                this.ngxUiLoaderService.stop();
                if (response && response.status === "success") {
                  // Update ispinned from API response (map is_pinned to ispinned)
                  if (response.responsebody && response.responsebody.is_pinned !== undefined) {
                    data.ispinned = response.responsebody.is_pinned;
                  }
                  this.toastr.success(response.statusmessage || 'Message pinned successfully', '', {
                    timeOut: 3000,
                    positionClass: 'toast-bottom-right'
                  });
                  // Clear pin message fields after successful pinning
                  this.pinMessageReason = '';
                  this.pinMessagePinName = '';
                } else {
                  // API returned failure status
                  this.toastr.error(response?.statusmessage || 'Failed to pin message. Please try again.', '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                  });
                }
              },
              error => {
                this.ngxUiLoaderService.stop();
                this.toastr.error('Failed to pin message. Please try again.', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right'
                });
              }
            );
          } else {
            // User cancelled - clear fields
            this.pinMessageReason = '';
            this.pinMessagePinName = '';
          }
        },
        (dismiss) => {
          this.modalWasOpen = false;
          this.untrackModalRef(modalRef);
          // User cancelled or closed - clear fields
          this.pinMessageReason = '';
          this.pinMessagePinName = '';
        }
      );
    }
  }

  // Validate and pin message - called from pin message dialog
  validateAndPinMessage(modal: any): void {
    const trimmedReason = (this.pinMessageReason || '').trim();
    const trimmedPinName = (this.pinMessagePinName || '').trim();

    if (!trimmedReason || !trimmedPinName) {
      if (!trimmedReason) {
        this.toastr.error('Reason is required', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
      if (!trimmedPinName) {
        this.toastr.error('Pin Name is required', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
      return;
    }

    // Validation passed - close modal with confirm
    modal.close('confirm');
  }

  HL7Viewer(message: string) {
  if (message === "") {
    this.toastr.error("The given input is empty", "", {
      timeOut: 4000,
      positionClass: "toast-bottom-right",
    });
    return;
  }

  if (!message.startsWith('MSH|^')) {
    this.toastr.error("The given input is not in HL7 format", "", {
      timeOut: 4000,
      positionClass: "toast-bottom-right",
    });
    return;
  }

  const formattedMessage = this.formatHL7Data(message);

  const modalRef = this.modalService.open(Hl7viewerComponent, {
    windowClass: "myCustomModalClass",
    backdrop: 'static',
    keyboard: false
  });
  modalRef.componentInstance.inputDataInModalComponent = formattedMessage;
  this.trackModalRef(modalRef, "myCustomModalClass");
  this.adjustModalHeight("myCustomModalClass");
  
  modalRef.result.then(() => {
    this.untrackModalRef(modalRef);
  }, (reason) => {
    this.untrackModalRef(modalRef);
  });
  
  // Set data attribute to identify the nested hl7viewer modal and backdrop
  setTimeout(() => {
    const modalElement = document.querySelector('.modal.myCustomModalClass.show') as HTMLElement;
    if (modalElement && !modalElement.hasAttribute('data-hubmessages-modal')) {
      modalElement.setAttribute('data-hubmessages-hl7viewer-modal', 'true');
    }
    const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
    if (backdrop && !backdrop.hasAttribute('data-hubmessages-modal')) {
      backdrop.setAttribute('data-hubmessages-hl7viewer-modal', 'true');
    }
  }, 100);
  
  this.modalWasOpen = true;
}

private formatHL7Data(data: string): string {
  if (data === "") return "";

  data = data.replace(/\[tempData1\]/g, ""); // remove placeholders
  return data.replace(/\[tempData\]/g, "\n"); // add line breaks
}
  async Dataexportreport() {
    let datacons = [];
    let result = [];
    this.newmsglistexportdata.forEach(element => {
      let result = {
        "id": element.routedefinitionid,
        "messageid": element.messageid
      }
      datacons.push(result);
    });
    var apiname = 'api/Routes/ExportPipelineFileData';
    this.ngxUiLoaderService.start();
    let response = await this.service.searchpostapi(apiname, datacons);
    if (response == null) {
      this.ngxUiLoaderService.stop();
      this.toastr.error("Given input data got the empty response", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
    }
    else {
      this.exportToCsv(response, this.dataExtractRouteName);
      this.ngxUiLoaderService.stop();
      this.toastr.success("File downloaded successfully", "", {
        timeOut: 500,
        positionClass: "toast-bottom-right",
      });
    }
    this.ngxUiLoaderService.stop();
  }

  exportToCsv(items: any[], fileName: string): void {

    let finalArrya = []; let selectedItems = [];
    for (let [key, value] of Object.entries(items)) {
      let obj = {
        messageid: key.split(":")[1],
        dataValue: value
      }
      finalArrya.push(obj)
    }

    finalArrya.forEach(element => {
      element.dataValue.forEach(item => {
        let messageobj = {
          "Messageid": element.messageid,
          "Key": item.key,
          "Value": item.value
        }
        selectedItems.push(messageobj);
      })
    });
    if (selectedItems.length > 0) {
      this.CsvDataExtract = this.CSVDataExtract(selectedItems, [
        "Messageid",
        "Key",
        "Value"
      ]);

      let blob = new Blob(["\ufeff" + this.CsvDataExtract], {
        type: "text/csv;charset=utf-8;",
      });
      let dwldLink = document.createElement("a");
      let url = URL.createObjectURL(blob);

      dwldLink.setAttribute("href", url);
      dwldLink.setAttribute("download", "DataExtract.csv");
      dwldLink.style.visibility = "hidden";
      document.body.appendChild(dwldLink);
      dwldLink.click();
      document.body.removeChild(dwldLink);
    }
    else {
      this.toastr.warning("There is no data !", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
    }
  }

  CSVDataExtract(objArray, headerscus) {
    let items = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let separator = ",";
    const columns = Object.keys(items[0]).join(separator);
    const body = items
      .map(item => Object.values(item).join(separator))
      .join("\n");
    if (headerscus == "") {
      return columns + "\n" + body;
    } else {
      return headerscus + "\n" + body;
    }
  }

  iconsList = [];
  openMessage(modalrefid, uniq, displaymessageid, messagetypefiledownload) {

    uniq.messageid = displaymessageid;
    uniq.messagetype = messagetypefiledownload;
    this.selectedMessage = uniq;
    this.ngxUiLoaderService.start();
    var apiname = "api/HubMessage/GetHubMessageLog?messagereferenceid=" + uniq.id + "&isarchivemessage=" + this.archivedbcheck;
    this.service.getapiurl(apiname).subscribe(
      (data) => {
        // Process serialized data with datetime conversion
        data = this.service.processSerializedDataWithDateTimeConversion(data);
        
        this.ngxUiLoaderService.stop();
        if (data.length > 0) {
          data = data.filter((va) => va.stagename.toLowerCase() !== "accepted");
          this.iconsList = data.sort((a, b) => a.stage - b.stage);
          const acknowledgedStages = this.iconsList.filter(item => item.stagename.toLowerCase() === "acknowledged");

          acknowledgedStages.sort((a, b) => {
            const dateA = new Date(a.createddate).getTime();
            const dateB = new Date(b.createddate).getTime();

            if (isNaN(dateA) || isNaN(dateB)) {
              return 0;
            }
            return dateA - dateB;
          });

          this.iconsList = [
            ...this.iconsList.filter(item => item.stagename.toLowerCase() !== "acknowledged"),
            ...acknowledgedStages
          ];

         this.releasebtn = this.iconsList.some(
  (dataItem) =>
    dataItem.stagedisplay === "H" &&
    dataItem.stagename.toLowerCase() === "hold"
);
          const viewstagesModalRef = this.modalService
            .open(modalrefid, {
              windowClass: "viewstagesmsg",
              backdrop: "static",
              keyboard: false,
            });
          
          this.trackModalRef(viewstagesModalRef, "viewstagesmsg");
          this.adjustModalHeight("viewstagesmsg");
          
          viewstagesModalRef.result.then(
            (result) => { 
              this.modalWasOpen = false;
              this.untrackModalRef(viewstagesModalRef);
            },
            (reason) => {
              this.modalWasOpen = false;
              this.untrackModalRef(viewstagesModalRef);
            }
          );
          
          // Add data attribute to identify the modal
          setTimeout(() => {
            const modalElement = document.querySelector('.modal.viewstagesmsg') as HTMLElement;
            if (modalElement) {
              modalElement.setAttribute('data-hubmessages-modal', 'true');
            }
          }, 0);
          
          this.modalWasOpen = true;
          
          this.iconsList.map((icon, index) => {
            icon["isActive"] = index === 0 ? true : false;
          });
          this.transformedStage(0);
        } else {
          this.toastr.warning("Stage data not found", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        }
      },
      (error) => {
        this.ngxUiLoaderService.stop();
      }
    );
  }

  hideModals() {
    // Only hide if we have open modals tracked in currentModalRefs
    if (this.currentModalRefs && this.currentModalRefs.length > 0 && this.modalRefsTracked && this.modalRefsTracked.length > 0) {
      // Get only the windowClasses that THIS component opened
      const ownedModalClasses = this.modalRefsTracked.map(m => m.windowClass).filter(cls => cls && cls !== '');
      
      if (ownedModalClasses.length === 0) {
        return; // No modals owned by this component
      }
      
      // Find all modals with classes THIS component owns
      const selector = ownedModalClasses.map(cls => `.modal.${cls}`).join(', ');
      let allModalElements = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
      
      // If not found by windowClass, try by data attribute
      if (allModalElements.length === 0) {
        allModalElements = document.querySelectorAll('.modal[data-hubmessages-modal="true"]') as NodeListOf<HTMLElement>;
      }
      
      if (allModalElements.length > 0) {
        this.modalWasOpen = true;
        
        // Hide all modals that belong to THIS component
        allModalElements.forEach(modalElement => {
          const style = window.getComputedStyle(modalElement);
          // Only hide if it's actually visible AND has one of the classes THIS component owns
          const hasOwnedClass = ownedModalClasses.some(className => modalElement.classList.contains(className));
          if ((modalElement.classList.contains('show') || (style.display !== 'none' && style.display !== '')) && 
              this.currentModalRefs.length > 0 && hasOwnedClass) {
            modalElement.setAttribute('data-hubmessages-modal', 'true');
            modalElement.style.setProperty('display', 'none', 'important');
            // DO NOT remove 'show' class - this prevents Bootstrap from auto-dismissing
          }
        });
        
        // Hide all backdrops
        const allBackdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
        allBackdrops.forEach(backdrop => {
          const backdropStyle = window.getComputedStyle(backdrop);
          if (backdropStyle.display !== 'none' && !backdrop.hasAttribute('data-create-modal') && !backdrop.hasAttribute('data-w700jobslist-modal') && !backdrop.hasAttribute('data-userrole-modal')) {
            backdrop.setAttribute('data-hubmessages-modal', 'true');
            backdrop.style.setProperty('display', 'none', 'important');
            // DO NOT remove 'show' class from backdrop - keep structure intact
          }
        });
        
        // Also hide nested hl7viewer modals (nested modal scenario)
        let nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClass[data-hubmessages-hl7viewer-modal="true"]') as NodeListOf<HTMLElement>;
        // Fallback to class name if data attribute not found
        if (nestedHl7Modals.length === 0) {
          nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClass') as NodeListOf<HTMLElement>;
        }
        nestedHl7Modals.forEach(nestedModal => {
          const nestedStyle = window.getComputedStyle(nestedModal);
          // Only hide if it's visible and not already marked as hubmessages-modal
          if ((nestedModal.classList.contains('show') || (nestedStyle.display !== 'none' && nestedStyle.display !== '')) && 
              !nestedModal.hasAttribute('data-hubmessages-modal')) {
            nestedModal.setAttribute('data-hubmessages-hl7viewer-modal', 'true');
            nestedModal.style.setProperty('display', 'none', 'important');
            // Keep 'show' class to prevent dismissal
          }
        });
        
        // Also hide nested hl7viewer modal backdrops
        const nestedHl7Backdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
        nestedHl7Backdrops.forEach(nestedBackdrop => {
          const backdropStyle = window.getComputedStyle(nestedBackdrop);
          // Hide if visible and not already marked as hubmessages-modal
          if (backdropStyle.display !== 'none' && !nestedBackdrop.hasAttribute('data-hubmessages-modal') && !nestedBackdrop.hasAttribute('data-create-modal') && !nestedBackdrop.hasAttribute('data-w700jobslist-modal') && !nestedBackdrop.hasAttribute('data-userrole-modal')) {
            nestedBackdrop.setAttribute('data-hubmessages-hl7viewer-modal', 'true');
            nestedBackdrop.style.setProperty('display', 'none', 'important');
          }
        });
        
        document.body.classList.remove('modal-open');
      } else {
        // No modal found but we have tracked refs - keep modalWasOpen true if we have tracked modals
        this.modalWasOpen = this.currentModalRefs.length > 0;
      }
    } else {
      // No tracked modals - nothing to hide
      this.modalWasOpen = false;
    }
  }

  showModals() {
    // Only show if modal was open when tab became inactive
    if (this.modalWasOpen) {
      setTimeout(() => {
        // Get only the windowClasses that THIS component opened
        const ownedModalClasses = this.modalRefsTracked && this.modalRefsTracked.length > 0 
          ? this.modalRefsTracked.map(m => m.windowClass).filter(cls => cls && cls !== '')
          : [];
        
        if (ownedModalClasses.length === 0) {
          this.modalWasOpen = false;
          return; // No modals owned by this component
        }
        
        // Find all modals with classes THIS component owns
        const selector = ownedModalClasses.map(cls => `.modal.${cls}`).join(', ');
        let modalElements = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
        
        // If not found by windowClass, try by data attribute
        if (modalElements.length === 0) {
          modalElements = document.querySelectorAll('.modal[data-hubmessages-modal="true"]') as NodeListOf<HTMLElement>;
        }
        
        // Only show if we still have tracked modals (they weren't closed)
        if (modalElements.length > 0 && this.currentModalRefs && this.currentModalRefs.length > 0) {
          // Show all modals that belong to THIS component
          modalElements.forEach(modalElement => {
            const style = window.getComputedStyle(modalElement);
            // Only show if it has one of the classes THIS component owns
            const hasOwnedClass = ownedModalClasses.some(className => modalElement.classList.contains(className));
            if (hasOwnedClass && (style.display === 'none' || !modalElement.classList.contains('show'))) {
              modalElement.style.setProperty('display', 'block', 'important');
              if (!modalElement.classList.contains('show')) {
                modalElement.classList.add('show');
              }
            }
          });
          
          // Show all backdrops that were hidden (prefer those marked with data attribute)
          let backdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-hubmessages-modal="true"]')) as HTMLElement[];
          
          backdrops.forEach(backdrop => {
            const backdropStyle = window.getComputedStyle(backdrop);
            if (backdropStyle.display === 'none') {
              backdrop.style.setProperty('display', 'block', 'important');
              if (!backdrop.classList.contains('show')) {
                backdrop.classList.add('show');
              }
            }
          });
          
          // Also show nested hl7viewer modals if they were open (nested modal scenario)
          let nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClass[data-hubmessages-hl7viewer-modal="true"]') as NodeListOf<HTMLElement>;
          // Fallback to class name if data attribute not found
          if (nestedHl7Modals.length === 0) {
            nestedHl7Modals = document.querySelectorAll('.modal.myCustomModalClass') as NodeListOf<HTMLElement>;
          }
          nestedHl7Modals.forEach(nestedModal => {
            const nestedStyle = window.getComputedStyle(nestedModal);
            // Show if it was hidden (display: none) - meaning it was open before
            if ((nestedStyle.display === 'none' || !nestedModal.classList.contains('show')) && 
                !nestedModal.hasAttribute('data-hubmessages-modal')) {
              nestedModal.style.setProperty('display', 'block', 'important');
              if (!nestedModal.classList.contains('show')) {
                nestedModal.classList.add('show');
              }
            }
          });
          
          // Also show nested hl7viewer modal backdrops
          let nestedHl7Backdrops = Array.from(document.querySelectorAll('.modal-backdrop[data-hubmessages-hl7viewer-modal="true"]')) as HTMLElement[];
          // If no backdrops found by data attribute, find all backdrops that aren't marked as hubmessages/create modal
          if (nestedHl7Backdrops.length === 0) {
            const allBackdrops = Array.from(document.querySelectorAll('.modal-backdrop')) as HTMLElement[];
            nestedHl7Backdrops = allBackdrops.filter(backdrop => !backdrop.hasAttribute('data-hubmessages-modal') && !backdrop.hasAttribute('data-create-modal') && !backdrop.hasAttribute('data-w700jobslist-modal') && !backdrop.hasAttribute('data-userrole-modal'));
          }
          nestedHl7Backdrops.forEach(nestedBackdrop => {
            const backdropStyle = window.getComputedStyle(nestedBackdrop);
            if (backdropStyle.display === 'none') {
              nestedBackdrop.style.setProperty('display', 'block', 'important');
              if (!nestedBackdrop.classList.contains('show')) {
                nestedBackdrop.classList.add('show');
              }
            }
          });
          
          document.body.classList.add('modal-open');
          
          // Verify modals are visible after a brief moment
          setTimeout(() => {
            // Double-check we still have tracked modals (user didn't close it)
            if (this.currentModalRefs && this.currentModalRefs.length > 0) {
              modalElements.forEach(modalElement => {
                const style = window.getComputedStyle(modalElement);
                if (style.display === 'none' || !modalElement.classList.contains('show')) {
                  // If Bootstrap hid it again, force show it
                  modalElement.style.setProperty('display', 'block', 'important');
                  modalElement.classList.add('show');
                }
              });
            }
          }, 200);
        } else {
          // If modal not found or no tracked modals, reset the flag
          if (!this.currentModalRefs || this.currentModalRefs.length === 0) {
            this.modalWasOpen = false;
          }
        }
      }, 150);
    }
  }

  // Adjust modal height based on window.innerHeight while preserving top and left positions
  private adjustModalHeight(windowClass: string) {
    setTimeout(() => {
      const viewportHeight = window.innerHeight;
      const headerElement = document.querySelector('.row.white') as HTMLElement;
      const headerHeight = headerElement ? headerElement.getBoundingClientRect().height : 60;
      
      // Calculate modal height (viewport height - header - some padding)
      const modalHeight = viewportHeight - headerHeight - 30;
      
      // Find the modal element by windowClass
      const modalElement = document.querySelector(`.modal.${windowClass}`) as HTMLElement;
      if (modalElement) {
        // Get existing top and left positions from computed style or inline style
        const computedStyle = window.getComputedStyle(modalElement);
        const existingTop = modalElement.style.top || (computedStyle.top !== 'auto' ? computedStyle.top : '');
        const existingLeft = modalElement.style.left || (computedStyle.left !== 'auto' ? computedStyle.left : '');
        
        // Only adjust height, preserve top and left if they exist
        modalElement.style.height = `${modalHeight}px`;
        if (existingTop && existingTop !== 'auto' && existingTop !== '') {
          modalElement.style.top = existingTop;
        }
        if (existingLeft && existingLeft !== 'auto' && existingLeft !== '') {
          modalElement.style.left = existingLeft;
        }
      }
      
      // Also adjust backdrop height (preserve top and left)
      const backdrop = document.querySelector('.modal-backdrop.show') as HTMLElement;
      if (backdrop) {
        const backdropComputedStyle = window.getComputedStyle(backdrop);
        const backdropExistingTop = backdrop.style.top || (backdropComputedStyle.top !== 'auto' ? backdropComputedStyle.top : '');
        const backdropExistingLeft = backdrop.style.left || (backdropComputedStyle.left !== 'auto' ? backdropComputedStyle.left : '');
        
        backdrop.style.height = `${modalHeight}px`;
        if (backdropExistingTop && backdropExistingTop !== 'auto' && backdropExistingTop !== '') {
          backdrop.style.top = backdropExistingTop;
        }
        if (backdropExistingLeft && backdropExistingLeft !== 'auto' && backdropExistingLeft !== '') {
          backdrop.style.left = backdropExistingLeft;
        }
      }
    }, 100);
  }

  // Adjust all open modals on window resize
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      // Find all open modals with hubmessages data attribute
      const modalElements = document.querySelectorAll('.modal.show[data-hubmessages-modal="true"]') as NodeListOf<HTMLElement>;
      modalElements.forEach(modalElement => {
        // Find which windowClass this modal has
        const windowClasses = ['messageiot', 'myCustomModalClass', 'modalConfig', 'TraceLogsModalClass', 
                              'Mode_Boot', 'viewstagesmsg', 'entityModalClass', 'compare-pinned-modal', 
                              'myCustomModalViewfile', 'pinMessageModalClass', 'PopupScreen', 'myCustomModalClassfailedstage'];
        for (const windowClass of windowClasses) {
          if (modalElement.classList.contains(windowClass)) {
            this.adjustModalHeight(windowClass);
            break;
          }
        }
      });
    }
  }

selectedInputbackup:any
selectedOutputbackup:any
 async transformedStage(index: number) {
    this.iconsList.map((va) => (va.isActive = false));
    this.iconsList[index].isActive = true;
    if (this.iconsList[index] != "") {
      this.selectedStageData = this.iconsList[index];
      this.selectedMessage.stagename = this.iconsList[index].stagename;
      if (this.isJsonString(this.iconsList[index].stageinput)) {
        this.selectedInputbackup = this.formatJson(this.iconsList[index].stageinput);
        this.selectedInput = await parseFlattenToPairs(this.iconsList[index].stageinput);
      } else {
        this.selectedInputbackup =this.iconsList[index].stageinput
        this.selectedInput = this.iconsList[index].stageinput;
      }
      if (this.isJsonString(this.iconsList[index].outputdata)) {
        this.selectedOutputbackup = this.formatJson(this.iconsList[index].outputdata);
        this.selectedOutput = await parseFlattenToPairs(this.iconsList[index].outputdata);
      } else {
        this.selectedOutputbackup = this.iconsList[index].outputdata;
        this.selectedOutput = this.iconsList[index].outputdata;
      }
    } else {
      this.selectedInput = "";
      this.selectedOutput = "";
    }
  }

  downloadFileById(fileId: string, messageId) {
    if (!fileId) {
      this.toastr.error('Download Failed, FileID is Empty', "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
      return;
    }
    try {
      const parsedFileArray = JSON.parse(fileId);

      if (Array.isArray(parsedFileArray) && parsedFileArray.length > 0) {
        parsedFileArray.forEach((file) => {
          if (!file.fileid) {
            this.toastr.error('Download Failed, FileID is Empty', "", {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            });
            return;
          }
          this.downloadcontents(file.fileid, file.filename, "download", "", messageId);
        });
      } else {
        if (typeof fileId === 'string' && fileId.trim() !== '') {
          this.downloadcontents(fileId, "", "download", "", messageId);
        } else {
          this.toastr.error('Download Failed, FileID is Empty', "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        }
      }
    } catch (error) {
      this.toastr.error('Download Failed, Invalid FileID format', "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
    }
  }



  isJsonString(str: string): boolean {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  formatJson(jsonString: string): string {
    const parsedData = JSON.parse(jsonString);
    return JSON.stringify(parsedData, null, 2);
  }

  JsonParse(jsonString: string): any {
    try {
      return this.isJsonString(jsonString) ? JSON.parse(jsonString) : jsonString;
    } catch (e) {
      return false;
    }
  }

  getAttributesForId(messageId: number) {
    const attributes = this.messageFullData[this.selectedIndexTab]?.messageAttributes.filter(attr => Number(attr.Messageid) === messageId) || [];
    return attributes;
  }

  private getAttributesFromEntitySearches(messageId: number, entitySearches: any[]) {
    return entitySearches.filter(attr => Number(attr.Messageid) === Number(messageId));
  }

  private collectExportDynamicColumnKeys(entitySearches: any[]): void {
    (entitySearches || []).forEach(attr => {
      if (attr?.Searchkey) {
        this.exportDynamicColumnKeys.add(attr.Searchkey);
      }
    });
  }

  getChildAttributes(messageId: number) {
    const attributes = this.messageFullData[this.selectedIndexTab]?.childmessageAttributes.filter(attr => String(attr.Messageid) === String(messageId)) || [];
    return attributes;
  }

  getChildMessages(parentmessageid: string) {
    const childmessages = this.messageFullData[this.selectedIndexTab]?.hubchildmessagedata?.filter(
      message => message.parentmessageid === parentmessageid
    ) || [];
    return childmessages;
  }

  getTitleForAttributes(messageId: number) {
    const attributes = this.getAttributesForId(messageId);
    return attributes.map(item => `${item.Searchkey}: ${item.SearchValue}`).join(' | ');
  }

  async openfailedstage(
    modal: any,
    item: any,
    messageId: string,
    routedefinitionid: string
  ) {
    if (!item) {
      return;
    }
    this.displaymessageid = messageId;
    this.displaystage = item.stagename;
    this.messagereferenceid = item.messagereferenceid;
    if (item.stagedisplay == "H" && item.stagename.toLowerCase() === "hold") {
      this.releasebtn = true;
    } else {
      this.releasebtn = false;
    }

    this.InputData = Array.isArray(item.stageinput)? item.stageinput[0] : item.stageinput;
    this.InputDatabackup = await parseFlattenToPairs(item.stageinput);

    this.OutputData = Array.isArray(item.outputdata)? item.outputdata[0] : item.outputdata;
    this.OutputDatabackup = await parseFlattenToPairs(item.outputdata);

    this.FileId = item.fileid;

    this.inputmediatypedisplay = true;
    this.outputmediatypedisplay = true;
    this.dataview = false;

    const failedStageModalRef = this.modalService
      .open(modal, {
        windowClass: "myCustomModalClassfailedstage",
        backdrop: "static",
        keyboard: false,
      });
    this.trackModalRef(failedStageModalRef, "myCustomModalClassfailedstage");
    this.adjustModalHeight("myCustomModalClassfailedstage");
    
    // Set data attribute to identify the modal and backdrop
    setTimeout(() => {
      const modalElement = document.querySelector('.modal.myCustomModalClassfailedstage') as HTMLElement;
      if (modalElement) {
        modalElement.setAttribute('data-hubmessages-modal', 'true');
      }
      const backdrop = document.querySelector('.modal-backdrop') as HTMLElement;
      if (backdrop) {
        backdrop.setAttribute('data-hubmessages-modal', 'true');
      }
    }, 0);
    
    failedStageModalRef.result.then(
      (result) => {
        this.modalWasOpen = false;
        this.untrackModalRef(failedStageModalRef);
      },
      (reason) => {
        this.modalWasOpen = false;
        this.untrackModalRef(failedStageModalRef);
      }
    );
  }

  /** UTC API value → selected timezone (see CommonService.formatDateTimeForDisplay). */
  formatHubDate(
    datetime: string | null | undefined,
    displayFormat = 'MM/dd/yyyy HH:mm:ss'
  ): string {
    if (!datetime) {
      return '';
    }
    return this.service.formatDateTimeForDisplay(datetime, displayFormat);
  }

  formatHubCreatedDate(createddate: string | null | undefined): string {
    return this.formatHubDate(createddate);
  }

  formatHubReprocessedDate(reprocessedDate: string | null | undefined): string {
    return this.formatHubDate(reprocessedDate, 'M/d/yyyy h:mm:ss a');
  }

  formatHubResolvedDate(resolvedDate: string | null | undefined): string {
    return this.formatHubDate(resolvedDate, 'M/d/yyyy h:mm:ss a');
  }

  /**
   * Stage icon tooltip — API createddate is UTC; convert once to header timezone.
   * Must stay aligned with formatHubDate (not browser local / not double-converted).
   */
  titlestage(item: any): string {
    const stageName = item?.stagename ?? '';
    const formattedDate = this.formatHubDate(
      item?.createddate,
      'MM/dd/yyyy hh:mm:ss a'
    );
    return formattedDate ? `${stageName}\n${formattedDate}` : stageName;
  }

  checkEllipsisHover(event: MouseEvent) {
    const element = event.currentTarget as HTMLElement;
    const rect = element.getBoundingClientRect();
    const mouseX = event.clientX;
    const elementWidth = rect.width;
    const overflowAreaWidth = 20;

    const isOverflowing = element.scrollWidth > element.clientWidth;
    this.isEllipsisVisible = isOverflowing && mouseX > rect.right - overflowAreaWidth;
  }
  copyAttributes(event: MouseEvent, messageId: number) {
    if (this.isEllipsisVisible) {
      this.copyToClip(this.getTitleForAttributes(messageId), 'Message Attributes');
    }
  }

  handleInnerClick(event: MouseEvent, id: any): void {
    if (this.getAttributesForId(id).length !== 0) {
      this.copyAttributes(event, id);
      event.stopPropagation();
    }
  }

  async GetDisplayNameByEncrypt(event: any) {
    var val = event;
    if (val) {
      this.isLoadingroutes = true;
      var apiname = "api/Routes/GetDisplayNameByEncrypt?encryptedurl=" + val;
      await this.service.getapiurl(apiname).subscribe({
        next: async data => {
          await this.getMessagestatuslist("msgstatus");
          this.selectedmessagestatustype = "failed";
          this.reactiveFormmsgstatus.patchValue({
            msgstatusname: this.selectedmessagestatustype
          });
          this.RouteNameList = data as any[];
          this.RouteNameList.map(obj => obj.displayname = `${obj.displayname}  ${'(' + obj.id + ')'}`);
          this.isLoadingroutes = false;
          if (this.RouteNameList.length == 1 && this.inputdata != '') {
            this.reactiveFormroute.patchValue({
              routename: this.RouteNameList[0]['displayname']
            });
            this.selectedrouteId = this.RouteNameList[0]['id']
            setTimeout(() => {
              this.rolepermission();
            }, 2000)
            this.SearchMessages(false);
          }
          if (data.length == 0) {
            this.notfounddata = true;
          }
          else {
            this.notfounddata = false;
          }
        },
        error: error => {
          this.isLoadingroutes = false;
          this.notfounddata = true;
        },
      });
    }
  }

  parentExpandedRows: Set<string> = new Set();
  expandtoparent() {
    this.isParentRouteExpanded = !this.isParentRouteExpanded;
    if(!this.isParentRouteExpanded){
      this.expandedRows.clear();
    }
    if (this.messageFullData[this.selectedIndexTab]?.childmessageList) {
      this.messageFullData[this.selectedIndexTab].childmessageList.forEach(child => {
        const parentMessageId = child?.parentmessageid;
        if (parentMessageId) {
            this.parentExpandedRows.add(parentMessageId);
        }
    });
  }
  }

  expandedRows: Set<string> = new Set();
  fetchedParentIds: Set<number> = new Set();


  toggleExpand(id: string, data?: any): void {
    if (this.expandedRows.has(id)) {
      this.expandedRows.delete(id); // Collapse
    }
    else if (this.isParentRouteExpanded && this.isExpanded ) {
      if (this.parentExpandedRows.has(id)) {
       this.parentExpandedRows.delete(id);
    }
    else {
      this.parentExpandedRows.add(id); 
    }
    }
     else {
      // Expand - check if we need to fetch children
      if (data && data.Isparent === 1 && !this.fetchedParentIds.has(data.id)) {
        this.fetchChildMessages(data.id);
      }
      this.expandedRows.add(id); // Expand
    }
  }

  // Fetch child messages on-demand when user expands a parent message
  fetchChildMessages(parentId: number): void {
    const apiUrl = `api/HubMessage/GetChildMessages?messageuniqueid=${parentId}&archivedbcheck=${this.archivedbcheck}`;
    this.ngxUiLoaderService.start();
    
    this.service.getapiurl(apiUrl).subscribe({
      next: (response: any) => {
        this.ngxUiLoaderService.stop();
        
        // Append child messages to existing arrays (don't overwrite)
        if (response.childhubmessagedata && response.childhubmessagedata.length > 0) {
          this.messageFullData[this.selectedIndexTab].childmessageList = 
            this.messageFullData[this.selectedIndexTab].childmessageList.concat(response.childhubmessagedata);
        }
        if (response.childhubmessagestage && response.childhubmessagestage.length > 0) {
          this.messageFullData[this.selectedIndexTab].childmessagestage = 
            this.messageFullData[this.selectedIndexTab].childmessagestage.concat(response.childhubmessagestage);
        }
        if (response.childhubentitySearches && response.childhubentitySearches.length > 0) {
          this.messageFullData[this.selectedIndexTab].childmessageAttributes = 
            this.messageFullData[this.selectedIndexTab].childmessageAttributes.concat(response.childhubentitySearches);
        }
        
        // Mark this parent as fetched
        this.fetchedParentIds.add(parentId);
      },
      error: (error) => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Failed to load child messages", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    });
  }

  isExpanded(id: string): boolean {
    return this.expandedRows.has(id);
  }

  isParentExpanded(id: string): boolean {
    return this.parentExpandedRows.has(id);
  }
  parentuiid:string='';
  hasChildMessagesForParent(id: string): boolean {
    this.parentuiid=id.toString();
    return this.messageFullData[this.selectedIndexTab].childmessageList.some(
      item => item.parentuireferenceid === String(id)
    );
  }
  parentMessageInfo: { hasChild: boolean, parentMessageId: string | null } | null = null;

  loadParentMessageInfo(messageId: string) {
    this.parentMessageInfo = this.hasParentMessage(messageId);
  }

  copyParentMessageId(parentMessageId: string, message: string): void {
    if (parentMessageId) {
      copyToClipboard(parentMessageId);
      this.toastr.success(`${message} Copied`, '', {
        timeOut: 500,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  hasParentMessage(id: string): { hasChild: boolean, parentMessageId: string | null } {
    const childMessage = this.messageFullData[this.selectedIndexTab].childmessageList.find(
      item => item.parentmessageid === id
    );

    if (childMessage) {
      return { hasChild: true, parentMessageId: childMessage.parentmessageid };
    }
    return { hasChild: false, parentMessageId: null };
  }

  stageDataCache: { [key: string]: any[] } = {};

  getStageById(childId: string) {
    if (this.stageDataCache[childId]) {
      return this.stageDataCache[childId];
    }
    const stageData = this.messageFullData[this.selectedIndexTab]?.childmessagestage.find(
      (item) => String(item.messagereferenceid) === String(childId)
    );
    if (stageData) {
      this.stageDataCache[childId] = stageData;
    }
    return stageData || null;
  }

  // trackByChildMessageId(index: number, childdata: any): any {
  //   return childdata.id;
  // }

  getConsistentId(array: any) {
    if (!array || array.length === 0) {
      return null; 
    }
  
    const keysToCheck = ['parentuireferenceid', 'messageid']; 
    for (const key of keysToCheck) {
      let arr=array.filter(V=>V[key]==this.parentuiid);
      if (arr[0][key] !== undefined) { 
        const firstId = arr[0][key]; 
        const isConsistent = arr.length>0?true:false; 
  
        if (isConsistent) {
          return { key, value: firstId }; 
        }
      }
    }
  
    return null; 
  }  
  
  getUniqueChildMessages(childMessages:any){
    const childMessage = this.messageFullData[this.selectedIndexTab]?.childmessageList;
  
    let keyToCheck = null; 
    if (childMessage) {
      const consistentId = this.getConsistentId(childMessage);
      if (consistentId) {
        keyToCheck = consistentId.key === 'parentuireferenceid' ? 'parentuireferenceid' : 'id';
      }
    } 
    if (!keyToCheck) {
      keyToCheck = 'id'; 
    }
    let retunarr=[];
    if(childMessages.length>0){
      retunarr=childMessages.filter((item) => 
        item.parentuireferenceid==this.parentuiid
      );
    }
    
  
    return retunarr.sort((a,b)=>b.id-a.id);
  }
  
  msgtocase(idtype,id:string,msgdata:any){
    let obj
    var apiname = "api/HubMessage/GetDeployment?routeid=" + msgdata.routedefinitionid;
    this.ngxUiLoaderService.start();
    this.service.getapiurl(apiname).subscribe((data:any)=> {
      this.ngxUiLoaderService.stop();
          if(data.status=='Success'){
            obj={
              type:idtype,
              value:id,
              dkey:JSON.parse(data.responsebody).deploymentkey
            };
            this.service.setmsgcaseObj(JSON.stringify(obj));
          }else{
            this.toastr.warning(data.statusmessage, '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          }
        });
  }
  entitySearchDetails = [];
  openEntity(modalrefid, id) {

    
    this.ngxUiLoaderService.start();
    var apiname = "api/HubMessage/GetEntitySearchDetails?messageid=" + id + "&isarchive=" + this.archivedbcheck;
    this.service.getapiurl(apiname).subscribe(
      (data) => {
        this.ngxUiLoaderService.stop();
        if (data && data.length > 0) {
          this.entitySearchDetails = data.map(item =>({
            key: item.Searchkey,
            value: item.SearchValue
          })).filter(item => item.value?.trim());

          const entityModalRef = this.modalService
            .open(modalrefid, {
              windowClass: "entityModalClass",
              size: 'lg',
              backdrop:'static',
              keyboard: false              
            });
          
          this.trackModalRef(entityModalRef, "entityModalClass");
          this.adjustModalHeight("entityModalClass");
          
          entityModalRef.result.then(
            (result) => { 
              this.modalWasOpen = false;
              this.untrackModalRef(entityModalRef);
            },
            (reason) => {
              this.modalWasOpen = false;
              this.untrackModalRef(entityModalRef);
            }
          );
          
          // Add data attribute to identify the modal
          setTimeout(() => {
            const modalElement = document.querySelector('.modal.entityModalClass') as HTMLElement;
            if (modalElement) {
              modalElement.setAttribute('data-hubmessages-modal', 'true');
            }
          }, 0);
          
          this.modalWasOpen = true;          
        } else {          
          this.toastr.warning('No records found',"", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        }
      },
      (error) => {
        this.ngxUiLoaderService.stop();        
        this.toastr.error('Failed to load entity details',"", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
      });
      }
    );
  }

  // -------------------------------------------------------------------------
  // Bulk file download — parent, standalone, or child (if checkbox-selected); max 10.
  // -------------------------------------------------------------------------

  // Returns bulk-download rows from checkbox selection (parent / standalone / child if selected).
  getBulkDownloadParentRows(selector: any, messageList: any[] = []): any[] {
    if (!selector?.selected?.length) {
      return [];
    }
    return selector.selected
      .map((item: any) => this.resolveExportMessageRow(item, messageList))
      .filter((row: any) => !!row); // drop unresolved rows only; children allowed when selected
  }

  // Count label for the bulk download button, e.g. "3 / 10".
  getBulkDownloadSelectionLabel(selector: any, messageList: any[] = []): string {
    const count = this.getBulkDownloadParentRows(selector, messageList).length;
    return `${count} / ${this.bulkDownloadMaxMessages}`;
  }

  // Eligible message count for bulk download (parent / standalone / child if selected).
  getBulkDownloadEligibleCount(selector: any, messageList: any[] = []): number {
    return this.getBulkDownloadParentRows(selector, messageList).length;
  }

  // True when user selected more than the configured maximum (10).
  isBulkDownloadOverLimit(selector: any, messageList: any[] = []): boolean {
    return this.getBulkDownloadEligibleCount(selector, messageList) > this.bulkDownloadMaxMessages;
  }

  // CSS class for selection count label: ok / empty / over limit.
  getBulkDownloadSelectionStatusClass(selector: any, messageList: any[] = []): string {
    const count = this.getBulkDownloadEligibleCount(selector, messageList);
    if (count === 0) {
      return 'bulk-download-count--none';
    }
    if (count > this.bulkDownloadMaxMessages) {
      return 'bulk-download-count--over';
    }
    return 'bulk-download-count--ok';
  }

  // How many messages the user must deselect to get back within the limit.
  getBulkDownloadOverLimitBy(selector: any, messageList: any[] = []): number {
    const count = this.getBulkDownloadEligibleCount(selector, messageList);
    return count > this.bulkDownloadMaxMessages ? count - this.bulkDownloadMaxMessages : 0;
  }

  // Download ZIP stays clickable for invalid cases (0 messages, no file type, >10) so onBulkDownloadZipClick() can show toasts.
  canBulkDownloadZipClick(): boolean {
    return !this.bulkDownloadInProgress;
  }

  private applyBulkDownloadFileTypeForMenu(type: 'input' | 'transformed' | 'both'): void {
    if (type === 'both') {
      this.bulkDownloadIncludeInput = true;
      this.bulkDownloadIncludeTransformed = true;
      this.bulkDownloadBothChecked = true;
      return;
    }
    if (type === 'input') {
      this.bulkDownloadIncludeInput = true;
      this.bulkDownloadIncludeTransformed = false;
      this.bulkDownloadBothChecked = false;
      return;
    }
    this.bulkDownloadIncludeInput = false;
    this.bulkDownloadIncludeTransformed = true;
    this.bulkDownloadBothChecked = false;
  }

  // Download ZIP click — validates limit and file type, then runs confirmBulkDownload().
  onBulkDownloadZipClick(): void {
    const selector = this.bulkDownloadPendingSelector ?? this.exportMenuSelector;
    const messageList = this.bulkDownloadPendingMessageList?.length
      ? this.bulkDownloadPendingMessageList
      : this.getExportMenuMessageList();
    const count = this.getBulkDownloadEligibleCount(selector, messageList);
    if (count === 0) {
      this.toastr.warning('Select at least one message (child messages cannot be downloaded).', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    if (count > this.bulkDownloadMaxMessages) {
      this.toastr.warning(
        `Cannot bulk download more than ${this.bulkDownloadMaxMessages} messages. You selected ${count}. Please deselect ${count - this.bulkDownloadMaxMessages} message(s).`,
        '',
        {
          timeOut: 5000,//taking longer time to download , please wait
          positionClass: 'toast-bottom-right',
        }
      );
      return;
    }
    if (!this.bulkDownloadIncludeInput && !this.bulkDownloadIncludeTransformed) {
      this.toastr.warning('Select Input, Transformed, or Both.', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    this.onBulkFileDownloadClick();
  }

  // Pills select file type only; user confirms with Download ZIP (no instant download).
  selectBulkDownloadFileType(type: 'input' | 'transformed' | 'both'): void {
    this.applyBulkDownloadFileTypeForMenu(type);
  }

  // EntitySearch value from grid (Accession# / Requisition#) for bulk download ZIP file naming.
  private getBulkDownloadEntitySearchValue(messageId: number, searchKey: string): string {
    const attrs = this.getAttributesForId(messageId);
    const match = attrs.find((a: any) => a.Searchkey === searchKey);
    return (match?.SearchValue || '').trim();
  }

  // POST to new bulk-download API and trigger browser ZIP save (non-blocking banner via bulkDownloadInProgress).
  confirmBulkDownload(): void {
    if (!this.bulkDownloadIncludeInput && !this.bulkDownloadIncludeTransformed) {
      this.toastr.warning('Select Input, Transformed, or Both.', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    const parents = this.getBulkDownloadParentRows(
      this.bulkDownloadPendingSelector,
      this.bulkDownloadPendingMessageList
    );
    if (parents.length === 0) {
      return;
    }
    const session = JSON.parse(sessionStorage.getItem('sessionObjectlogin') || '{}');
    const payload = {
      messageIds: parents.map((row: any) => row.id),
      // Required: grid row metadata from GetSearchDetails (UI-only bulk download; no usp_GetBulkDownloadMessagesByIds).
      messageContexts: parents.map((row: any) => ({
        id: row.id,
        messageid: row.messageid,
        fileid: row.fileid,
        messagetype: row.messagetype,
        Isparent: row.Isparent,
        parentmessageid: row.parentmessageid,
        // Optional ZIP naming: from grid EntitySearch; backend falls back to input parse then messageid.
        accessionno: this.getBulkDownloadEntitySearchValue(row.id, 'Accession#'),
        requisitionno: this.getBulkDownloadEntitySearchValue(row.id, 'Requisition#'),
      })),
      includeInput: this.bulkDownloadIncludeInput,
      includeTransformed: this.bulkDownloadIncludeTransformed,
      archivedbcheck: this.archivedbcheck,
      createdBy: session?.userdata?.['userid'] || '',
    };
    this.bulkDownloadProcessingCount = parents.length;
    this.closeMessagesExportMenu();
    // Global persistent toast + ZIP handling in CommonService (survives route changes).
    this.service.executeBulkDownloadWithGlobalToast(payload, parents.length);
  }

}
